import React from "react";
import { withRouter } from "react-router-dom";
import _ from 'lodash';
import { connect } from "react-redux";
import { registerUser } from "../../../react-cognito";
import { NotificationManager } from "react-notifications";
import store from "../../../store";
import { Loader } from "../../../components/loader";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import "react-phone-number-input/style.css";
import Steps, { Step } from "rc-steps";
import PetInfo from "../../../components/petInfo/petInfo";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import "react-select/dist/react-select.css";
import AvatarEditor from "react-avatar-editor";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import { NavLink } from "react-router-dom";
import fixOrientation from "fix-orientation";

import { fetchAnimalTypes } from "../../../actions/addAnimalType";
import {
  fetchBreedTypes,
  fetchBreedTypesByAnimal , fetchBreedInfo ,fetchUpdatedBreedTypeById
} from "../../../actions/addBreedType";
import { fetchRegTypes } from "../../../actions/regType";
import {fetchFoodTypes} from "../../../actions/foodType";
import {
  addMedicalRecord,
  attachAvatar,
  updatePrintMRecord,
  findPetById,
} from "../../../actions/medicalRecords";
import { fetchBreeders, fetchBreedCategory, fetchBreederDurartion, addBreeder, fetchBreederById  } from "../../../actions/breeders";
import { fetchAdministereds } from "../../../actions/administered";
import { getConfigByName } from "../../../actions/configuration";
import AddAnimalTypeForm from "../../settings/addAnimalType";
import AddAdministeredTypeForm from "../../settings/addAdministeredType";
import AddRegTypeForm from "../../settings/addRegisterType";
import AddBreedTypeForm from "../../settings/addBreedType";
import AddFoodTypeForm from "../../settings/breedFoodType";
import { BreadCrumb } from "../../../components/breadcrumb";
import MRecordPDF from "../../../components/mRecordPdf/mRecordPdf";
import { forceInputUppercase, resizeImage } from "../../../utils/helper";
import avatarConfig from '../../../avatarConfig';
import PerfectScrollbar from "react-perfect-scrollbar";
import config from "../../../config";
import Video from '../../../components/videoPlayer/wistia';
import PetNameSuggestion from '../../../components/openAi/nameSuggestionModal';
import PetDescriptionSuggestion from '../../../components/openAi/petDescriptionSuggestionModal';
import PetZodiacDescriptionSuggestion from "../../../components/openAi/petZodiacDescriptionSuggestionModal";
import axios from 'axios';
import zodiacData from '../../../zodiacData.json';
const $ = window.$;
const initialState = {
  showBreedEdit : false,
  littermate: false,
  mediModalType: "",
  country: "",
  currentStepNotValid: false,
  currentFormIncomplete: false,
  currentStep: 0,
  PetId: "",
  arrival_date: moment().toDate(),
  sex: "",
  weight: "",
  loading: false,
  pet_id: "",
  breedId: null,
  color_markings: "",
  date_of_birth: moment().toDate(),
  micro_chip: "",
  cross_breed: "NO",
  RegistrationTypeId: "",
  FoodTypeId: "",
  foodTypeImagePath : "",
  foodTypeImageName : "",
  sire: "",
  sire_number: "PENDING",
  dam: "",
  dam_number: "PENDING",
  new_breeder: false,
  BreederId: "N/A",
  b_usda: "",
  b_address_line_1: "",
  b_address_line_2: "",
  b_address_city: "",
  b_address_state: "",
  b_address_country: "",
  b_address_postal_code: "",
  b_phone: "",
  new_b_name: "",
  new_b_usda_no: "",
  new_b_address_line_1: "",
  new_b_address_line_2: "",
  new_b_address_city: "",
  new_b_address_state: "",
  new_b_address_country: "",
  new_b_address_postal_code: "",
  new_b_phone: "",
  toa: [],
  breeds: [],
  reg_types: [],
  foodTypes: [],
  breeders: [],
  selectedBreedData : {},
  validateArrivalDate : true,
  showArrivalDateValidateMessage : true,
  showDOBValidateMessage : true,
  petAgeOnArrival : "",
  medications: [
    // {date:'', MedicationId:'N/A', more_info: '',medType:'vaccine', id:0},
    // {date:'', MedicationId:'N/A', more_info: '',medType:'deworm', id:1}
  ],
  // administered: [],
  dewormings: [],
  vaccinations: [],

  // Image 01
  imgSrc01: "",
  imgName01: "",
  zoom01: 1,
  editor01: "",
  rotate01: 0,

  // Image 02
  imgSrc02: "",
  imgName02: "",
  zoom02: 1,
  editor02: "",
  rotate02: 0,

  // Image 03
  imgSrc03: "",
  imgName03: "",
  zoom03: 1,
  editor03: "",
  rotate03: 0,

  // Image 04
  imgSrc04: "",
  imgName04: "",
  zoom04: 1,
  editor04: "",
  rotate04: 0,

  // Image 05
  imgSrc05: "",
  imgName05: "",
  zoom05: 1,
  editor05: "",
  rotate05: 0,

  // Image 06
  imgSrc06: "",
  imgName06: "",
  zoom06: 1,
  editor06: "",
  rotate06: 0,
 
  // Image 07
  imgSrc07: "",
  imgName07: "",
  zoom07: 1,
  editor07: "",
  rotate07: 0,
 
  // Image 08
  imgSrc08: "",
  imgName08: "",
  zoom08: 1,
  editor08: "",
  rotate08: 0,
 
  // Image 09
  imgSrc09: "",
  imgName09: "",
  zoom09: 1,
  editor09: "",
  rotate09: 0,
 
  // Image 10
  imgSrc10: "",
  imgName10: "",
  zoom10: 1,
  editor10: "",
  rotate10: 0,

  selectedPrimaryImageOption: "1",

  mediCount: 2,
  notes: "",
  showAdministered: false,
  adult_weight: null,
  breed_category_id: null,
  breeds_category: [],
  availablePetId: true,
  loadingAvailableId: false,
  breeders_vaccine: [],
  breeders_vaccine_duration: [],
  breeder_vaccine_duration_days: "",
  breeders_vaccine_id: null,
  breeders_treatment_id: null,
  breeders_vaccine_duration_id: null,
  breeders_treatment_duration_id: null,
  breeders_assigned_vaccine: [],
  breeders_treatment: [],
  new_breederid: null,
  breedervaccinebyid: [],
  siredam_disable: false,
  pet_name: "",
  personality_description:"",
  personality_description_full:"",
  pet_zodiac: "",
  pet_zodiac_description: "",
  selectedVideoFile: null ,
  videoFileInputKey:"",
  loadedVideoFile: false,
  updatedVideoId: null,
  updatedVideoUrl: null,
  playStop: true,
  uploadVideo: null,
  loadingVideo:false,
  video_name: null,
  video_url:null,
  video_source:null,
  uploadPercentage: 0,
  videoHoster: null,
  multiImageArray:[],
  loadedImages:[],
  duplicateImages:[],
  newImgSrc:"",
  newZoom: 1,
  newRotate: 0,
  selectedImage: {},
  testURL:"",
  editedImages:[],
  newEditor:"",
  newSelectedPrimaryImageOption: false,
  isResize: false,
  namePrompt : '',
  descriptionPrompt : '',
  zodiacDescriptionPrompt: '',
  petType:'',
  petBreedName:'',  


  
};
const videoHoster = {
  vimeo : "vimeo",
  wistia : "wistia",
};
let newMedicalRecord = {};
let loadflag = false;
let form_step_0 = {};
let form_step_1 = {};
let form_step_2 = {
  medications: [
    { date: "", MedicationId: "", id: 0 },
    { date: "", MedicationId: "", id: 1 }
  ]
};
class Datamodal extends React.Component {
  constructor(props) {
    super(props);
  }

  state = initialState;

  submit = event => {
    this.setState({ loading: true });
    let status = this.state.currentFormIncomplete ? "draft" : "complete";
    newMedicalRecord = Object.assign(newMedicalRecord, {
      PetShopId: this.props.petShop.currentPetshop.id,
      mc_status: status
    });
    this.props.addMedicalRecord(newMedicalRecord);
  };
  checkValues = step_form => {
    let data = Object.entries(step_form).map(([key, value]) => {
      if (key === 'medications' && Array.isArray(value)) {
        var found = false;
        for (var i = 0; i < value.length; i++) {
          if (value[i].date === null) {
            found = true;
            break;
          }
          if (value[i].MedicationId === null) {
            found = true;
            break;
          }
        }
        if (found === true) {
          return "invalid";
        }
      }
      if(key === "pet_id" && value == null){
        return "invalid";
      }
      if (key !== 'weight' && value === "invalid") {
        return "invalid";
      }else if ( value === "invalidArrivalDate"){
        return "invalidArrivalDate";
      }else if (value === "invalid email") {
        return "invalid email";
      } else if (value === "incomplete") {
        return "incomplete";
      } else {
        return value;
      }
      
    });

    const arrivalDateValidation = this.state.currentStep === 0 ? data.indexOf("invalidArrivalDate") !== -1 ? !this.state.validateArrivalDate : this.state.validateArrivalDate : true ;
    const personalityDescriptionValidation = data.indexOf("InvalidDescription") !== -1 ? false : true ; 
    const petNameDescriptionValidation = data.indexOf("InvalidPetNameDescription") !== -1 ? false : true ;   
    if (data.indexOf("invalid") === -1 && data.indexOf("invalid email") === -1 && arrivalDateValidation && personalityDescriptionValidation && petNameDescriptionValidation) {
      newMedicalRecord = Object.assign(newMedicalRecord, step_form);
      // if(data.includes(null)){
      //     NotificationManager.warning("Incomplete details.Record will be saved as draft.");
      //     this.setState({currentFormIncomplete: true});
      // }
      if (this.state.currentStep === 2) {
        this.submit(step_form);
        return;
      }
      this.nextStep();
    } else {
      if(data.indexOf("invalid") !== -1 || (data.indexOf("invalidArrivalDate") !== -1 && this.state.validateArrivalDate)){
        NotificationManager.warning("Please check input details again.");
        this.setState({ currentStepNotValid: true });
      }else if(data.indexOf("invalid email") !== -1){
        NotificationManager.warning("Please assign email template to selected breed.");
      this.setState({ currentStepNotValid: true });
      }
      else if(data.indexOf("InvalidDescription") !== -1){
        NotificationManager.warning("Description length exceeds maximum");
      this.setState({ currentStepNotValid: true });
      }
    }
  };

  dateOfBirthRangeIsValid(dob) {
    return(
      moment(dob).diff(moment()) < 0
    )
  }

  arrivalDateIsValid(arrivalDate) {
    const PetArrivalDateInWeeks = config.petArrivalDateInWeeksFromDOB ? config.petArrivalDateInWeeksFromDOB : 8;
      return (
        moment(arrivalDate).diff(moment(this.state.date_of_birth) , 'week') >= PetArrivalDateInWeeks 
      );
  }

  skipArrivalDateValidation = status => {
    this.setState({validateArrivalDate : status});
  }

  validateStep = littermate => {
    if (littermate) {
      this.setState({ littermate: true });
    } else {
      this.setState({ littermate: false });
    }
    //Image 01 Upload
    var resizedImage01 = "";
    var image01Title = "";
    if (this.state.editor01 && this.state.imgSrc01) {
      resizedImage01 = this.state.editor01.getImage();
      resizedImage01 = resizeImage(resizedImage01, 1000, 1000);
    }

   // Image 02 Upload
    var resizedImage02 = "";
    var image02Title = "";
    if (this.state.editor02 && this.state.imgSrc02) {
      resizedImage02 = this.state.editor02.getImage();
      resizedImage02 = resizeImage(resizedImage02, 1000, 1000);
    }

    // Image 03 Upload
    var resizedImage03 = "";
    var image03Title = "";
    if (this.state.editor03 && this.state.imgSrc03) {
      resizedImage03 = this.state.editor03.getImage();
      resizedImage03 = resizeImage(resizedImage03, 1000, 1000);
    }

    // Image 04 Upload
    var resizedImage04 = "";
    var image04Title = "";
    if (this.state.editor04 && this.state.imgSrc04) {
      resizedImage04 = this.state.editor04.getImage();
      resizedImage04 = resizeImage(resizedImage04, 1000, 1000);
    }

    // Image 05 Upload
    var resizedImage05 = "";
    var image05Title = "";
    if (this.state.editor05 && this.state.imgSrc05) {
     resizedImage05 = this.state.editor05.getImage();
     resizedImage05 = resizeImage(resizedImage05, 1000, 1000);
    }

      // Image 06 Upload
    var resizedImage06 = "";
    var image06Title = "";
    if (this.state.editor06 && this.state.imgSrc06) {
      resizedImage06 = this.state.editor06.getImage();
      resizedImage06 = resizeImage(resizedImage06, 1000, 1000);
    }
    
    // Image 07 Upload
    var resizedImage07 = "";
    var image07Title = "";
    if (this.state.editor07 && this.state.imgSrc07) {
      resizedImage07 = this.state.editor07.getImage();
      resizedImage07 = resizeImage(resizedImage07, 1000, 1000);
    }
    
    // Image 08 Upload
    var resizedImage08 = "";
    var image08Title = "";
    if (this.state.editor08 && this.state.imgSrc08) {
      resizedImage08 = this.state.editor08.getImage();
      resizedImage08 = resizeImage(resizedImage08, 1000, 1000);
    }
    
    // Image 09 Upload
    var resizedImage09 = "";
    var image09Title = "";
    if (this.state.editor09 && this.state.imgSrc09) {
      resizedImage09 = this.state.editor09.getImage();
      resizedImage09 = resizeImage(resizedImage09, 1000, 1000);
    }

    // Image 10 Upload
    var resizedImage10 = "";
    var image10Title = "";
    if (this.state.editor10 && this.state.imgSrc10) {
      resizedImage10 = this.state.editor10.getImage();
      resizedImage10 = resizeImage(resizedImage10, 1000, 1000);
    }  
    let blankAvatar = {};

    if(this.state.loadedImages && this.state.loadedImages.length > 0){   
      resizedImage01 = resizedImage01;
      image01Title = this.state.loadedImages[0] ? this.state.loadedImages[0].name : "";
      resizedImage02 = resizedImage02;
      image02Title = this.state.loadedImages[1] ? this.state.loadedImages[1].name : "";
      resizedImage03 = resizedImage03;
      image03Title = this.state.loadedImages[2] ? this.state.loadedImages[2].name : "";
      resizedImage04 = resizedImage04;
      image04Title = this.state.loadedImages[3] ? this.state.loadedImages[3].name : "";
      resizedImage05 = resizedImage05;
      image05Title = this.state.loadedImages[4] ? this.state.loadedImages[4].name : "";
      resizedImage06 = resizedImage06;
      image06Title = this.state.loadedImages[5] ? this.state.loadedImages[5].name : "";
      resizedImage07 = resizedImage07;
      image07Title = this.state.loadedImages[6] ? this.state.loadedImages[6].name : "";
      resizedImage08 = resizedImage08; 
      image08Title = this.state.loadedImages[7] ? this.state.loadedImages[7].name : "";
      resizedImage09 = resizedImage09;
      image09Title = this.state.loadedImages[8] ? this.state.loadedImages[8].name : "";
      resizedImage10 = resizedImage10;
      image10Title = this.state.loadedImages[9] ? this.state.loadedImages[9].name : "";
  
    }else{
      blankAvatar = avatarConfig.blankAvatar;
    }
    switch (this.state.currentStep) {
      case 0:
        form_step_0 = {
         // Image 01
         avatar: resizedImage01.trim().length > 0 ? resizedImage01 : blankAvatar.avatar,
         avatar_title: image01Title,
         // Image 02
         image02: resizedImage02.trim().length > 0 ? resizedImage02 : null,
         image02_title: image02Title,
         // Image 03
         image03: resizedImage03.trim().length > 0 ? resizedImage03 : null,
         resizedImage03_title: image03Title,
         // Image 04
         image04: resizedImage04.trim().length > 0 ? resizedImage04 : null,
         image04_title: image04Title,
         // Image 05
         image05: resizedImage05.trim().length > 0 ? resizedImage05 : null,
         image05_title: image05Title,
         // Image 06
         image06: resizedImage06.trim().length > 0 ? resizedImage06 : null,
         image06_title: image06Title,
          // Image 07
          image07: resizedImage07.trim().length > 0 ? resizedImage07 : null,
          image07_title: image07Title,
          // Image 08
          image08: resizedImage08.trim().length > 0 ? resizedImage08 : null,
          image08_title: image08Title,
          // Image 09
          image09: resizedImage09.trim().length > 0 ? resizedImage09 : null,
          image09_title: image09Title,
          // Image 10
          image10: resizedImage10.trim().length > 0 ? resizedImage10 : null,
          image10_title: image10Title,
          top:
            this.state.PetId.toString().trim().length > 0
              ? this.state.PetId
              : "invalid",
          arrival: moment(this.state.arrival_date).format("YYYY-MM-DD"),
          sex: this.state.sex.trim().length > 0 ? this.state.sex : "invalid",
          weight:
            this.state.weight.trim().length > 0 ? this.state.weight : null,
          adult_weight:
            this.state.adult_weight && this.state.adult_weight.trim().length > 0 ? this.state.adult_weight : null,
          pet_id:
            this.state.pet_id.trim().length > 0 ? this.state.pet_id : null,
          breed:  this.state.breedId &&
            this.state.breedId.toString().trim() !== "none"
              ? this.state.breedId
              : "invalid",
          price:
            this.state.price > 0 ? this.state.price : null,
          color_markings:
            this.state.color_markings.trim().length > 0
              ? this.state.color_markings
              : null,
          dob: moment(this.state.date_of_birth).format("YYYY-MM-DD"),
          dob_range: this.dateOfBirthRangeIsValid(this.state.date_of_birth)
            ? null
            : "invalid",
          micro_chip:
            this.state.micro_chip.trim().length > 0
              ? this.state.micro_chip
              : null,
          cross_breed:
            this.state.cross_breed.trim().length > 0
              ? this.state.cross_breed
              : null,
          regType:
            this.state.RegistrationTypeId === "N/A"
              ? null
              : this.state.RegistrationTypeId,
          sire: this.state.sire.trim().length > 0 ? this.state.sire : null,
          FoodTypeId :
             this.state.FoodTypeId === ""
             ? null
             : this.state.FoodTypeId,
          sire_number:
            this.state.sire_number.trim().length > 0
              ? this.state.sire_number
              : null,
          dam: this.state.dam.trim().length > 0 ? this.state.dam : null,
          dam_number:
            this.state.dam_number.trim().length > 0
              ? this.state.dam_number
              : null,
          breed_category_id: this.state.breed_category_id &&
            this.state.breed_category_id.toString().trim() !== "none"
              ? this.state.breed_category_id
              : "invalid email",
          arrival_date_range: this.arrivalDateIsValid(this.state.arrival_date)
              ? null
              : "invalidArrivalDate",
          pet_name : this.state.pet_name ? this.state.pet_name : null,
          personality_description : this.state.personality_description ? this.state.personality_description.trim().length <= 2000 ? this.state.personality_description : "InvalidDescription":null,
          personality_description_full : this.state.personality_description_full ? this.state.personality_description_full:null,
          pet_zodiac: this.state.pet_zodiac ?  this.state.pet_zodiac : null,
          pet_zodiac_description: this.state.pet_zodiac_description ? this.state.pet_zodiac_description : null,
          video : this.state.selectedVideoFile ? this.state.selectedVideoFile : null,
          video_name : this.state.video_name && this.state.video_name.trim().length >0 ? this.state.video_name : null,
          video_id : this.state.updatedVideoId ? this.state.updatedVideoId : null,
          video_url : this.state.updatedVideoUrl ? this.state.updatedVideoUrl : null,
          video_source : this.state.video_source && this.state.video_source.trim().length > 0 ? this.state.video_source : null,
         };

        this.checkValues(form_step_0);
        break;
      case 1:     
        form_step_1 = {
          newBreeder: this.state.new_breeder,
          BreederId:
            this.state.BreederId === "N/A" ? null : this.state.BreederId
        };     
        this.checkValues(form_step_1);
        break;
      case 2:
        var newArray = this.state.medications.map(a => ({ ...a }));
        form_step_2 = {
          notes: this.state.notes.trim().length > 0 ? this.state.notes : null,
          medications: this.confirmMedications(newArray),
          breederAssignedVaccine: this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine : []
        };
        this.checkValues(form_step_2);
        break;
    }
  };

  confirmUploadingImages = (e) => {
    e.preventDefault();
    if (this.state.currentStep === 0 ){
    let selectedImages = this.state.loadedImages;
      if(selectedImages && selectedImages.length > 0){
      const primaryImageIndex = selectedImages.findIndex(img => img.isPrimary === true ); 
      selectedImages.push(...selectedImages.splice(0, primaryImageIndex));
      this.setState({ loadedImages : selectedImages}); 
      $("#image-preview-model").modal("show");
      }else{
        this.validateStep(false);
      }
   }else{
    this.validateStep(false);
   }

}

  confirmMedications = medications => {
    return medications.map(item => {
      if (!moment(item.date).isValid()) {
        item.date = null;
      }
      if (item.MedicationId === "N/A") {
        item.MedicationId = null;
      }
      return item;
    });
  };

  setImagesToUpload = () => {
    $("#image-preview-model").modal("hide");
    this.validateStep(false);
  }

  
  newBreederCreate = () => {
    if (this.state.new_breeder) {
      form_step_1 = {
        newBreeder: this.state.new_breeder,
        breeder:
          this.state.new_b_name.trim().length > 0
            ? this.state.new_b_name
            : "invalid",
        usda_no:
          this.state.new_b_usda_no.toString().trim().length > 0
            ? this.state.new_b_usda_no
            : "invalid",
        addressLine1:
          this.state.new_b_address_line_1.trim().length > 0
            ? this.state.new_b_address_line_1
            : "invalid",
        addressLine2:
          this.state.new_b_address_line_2.trim().length > 0
            ? this.state.new_b_address_line_2
            : "",
        addressCity:
          this.state.new_b_address_city.trim().length > 0
            ? this.state.new_b_address_city
            : "invalid",
        addressState:
          this.state.new_b_address_state.trim().length > 0
            ? this.state.new_b_address_state
            : "invalid",
        addressCountry:
          this.state.new_b_address_country.trim().length > 0
            ? this.state.new_b_address_country
            : "invalid",
        addressPostalCode:
          this.state.new_b_address_postal_code.trim().length > 0
            ? this.state.new_b_address_postal_code
            : "invalid",
        phone:
          this.state.new_b_phone.toString().trim().length > 0
            ? this.state.new_b_phone
            : "invalid",
        breederAssignedVaccine: this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine : [],
        confirmExisting: false
      };
      let data = Object.entries(form_step_1).map(([key, value]) => {
        if (key !== 'weight' && value === "invalid") {
          return "invalid";
        } else if (value === "incomplete") {
          return "incomplete";
        } else {
          return value;
        }
      });
      if (!data.includes("invalid")) {
        this.props.addBreeder(form_step_1);
      } else {
          NotificationManager.warning("Please check input details again.");
          this.setState({ currentStepNotValid: true });
      }
    }

  };
  existBreederCreate = () => {
    form_step_1 = {
      newBreeder: true,
      breeder:
        this.state.new_b_name.trim().length > 0
          ? this.state.new_b_name
          : "invalid",
      usda_no:
        this.state.new_b_usda_no.toString().trim().length > 0
          ? this.state.new_b_usda_no
          : "invalid",
      addressLine1:
        this.state.new_b_address_line_1.trim().length > 0
          ? this.state.new_b_address_line_1
          : "invalid",
      addressLine2:
        this.state.new_b_address_line_2.trim().length > 0
          ? this.state.new_b_address_line_2
          : "",
      addressCity:
        this.state.new_b_address_city.trim().length > 0
          ? this.state.new_b_address_city
          : "invalid",
      addressState:
        this.state.new_b_address_state.trim().length > 0
          ? this.state.new_b_address_state
          : "invalid",
      addressCountry:
        this.state.new_b_address_country.trim().length > 0
          ? this.state.new_b_address_country
          : "invalid",
      addressPostalCode:
        this.state.new_b_address_postal_code.trim().length > 0
          ? this.state.new_b_address_postal_code
          : "invalid",
      phone:
        this.state.new_b_phone.toString().trim().length > 0
          ? this.state.new_b_phone
          : "invalid",
      breederAssignedVaccine: this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine : [],
      confirmExisting: true
    };
    $("#confirm_breedersave_modal").modal("hide");
    this.props.addBreeder(form_step_1);   
  
  }

  changeSelectionVal = event => {
    let value = event.target.value;

    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  }


  changeVal = event => {
    let excludes = ["weight", "price","pet_name","personality_description"];
    if (!excludes.includes(event.target.name)) forceInputUppercase(event);

    let value = event.target.value;

    if (event.target.name === 'pet_id') value = value.split(" ").join("");

    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  changeAdultWeightVal = event => {

    let value = event.target.value;

    this.setState({
      adult_weight: value
    });
  };



  changeToa = selected => {
    if (selected) {     
      this.setState({ PetId: selected.value, petType : selected.label });
    }
  };

  changeBreed = selected => {
    if (!selected || selected.value) {     
      this.setState({ breedId: selected.value, petBreedName : selected.label });
    }
  };

  checkPet = event => {  
    forceInputUppercase(event);
    this.loadflag = false;
    let value = event.target.value;
    if (event.target.name === 'pet_id' && value.length > 6) { 
      this.loadflag = true;    
      value = value.split(" ").join("");
      let petobj = {
        pet_id: event.target.value
      }     
      this.props.findPetById(petobj);
    }

    this.setState({
      ...this.state,
      [event.target.name]: value,
    });
  };

  changeRegType = selected => {
    if (selected) {
      this.setState({ RegistrationTypeId: selected.value });
      if(selected.label=="NOT APPLICABLE"){
        this.setState({ dam_number:'NOT APPLICABLE', sire_number:'NOT APPLICABLE',  siredam_disable : true });
      }
      else{
        this.setState({ dam_number:'PENDING', sire_number:'PENDING',  siredam_disable : false });
      }
    }
  };

  changeFoodType = selected => {
    if (selected) {
      if(selected.label === "SELECT THE FOOD TYPE"){
        this.setState({ FoodTypeId: "" , foodTypeImagePath : "" , foodTypeImageName : ""});
      }else{
      this.setState({ FoodTypeId: selected.value , foodTypeImagePath : selected.foodTypeImagePath , foodTypeImageName : selected.foodTypeImageName});
    }}
  }

  changeBreeder = selected => {
    if (selected) {
      this.setState({ BreederId: selected.value }); 
    }
  };

  changeBreederVaccine = selected => {

    if (selected) {
      this.breeder_vaccine_label = selected.label;
      this.setState({ breeders_vaccine_id: selected.value });
    }
  };

  changeBreederTreatment = selected => {
    if (selected) {
      this.breeder_treatment_label = selected.label;
      this.setState({ breeders_treatment_id: selected.value });
    }
  };

  changeBreederVaccineDuration = selected => {
    if (selected) {   
      this.breeder_vaccine_duration_label = selected.label;
      this.breeder_vaccine_duration_days = selected.days;
      this.setState({ breeders_vaccine_duration_id: selected.value });
    }
  };

  changeBreederTreatmentDuration = selected => {
    if (selected) {
      this.breeder_treatment_duration_label = selected.label;
      this.breeder_treatment_duration_days = selected.days;

      this.setState({ breeders_treatment_duration_id: selected.value });
    }
  };

  changeBreedCategory = selected => {
    if (selected) {
      this.setState({ breed_category_id: selected.value });
    }
  };

  changeAdministered = (selected, i) => {
    var index = this.state.medications.findIndex(ele => {
      return ele.id == i;
    });
    if (selected) {
      this.setState({
        medications: [
          ...this.state.medications.slice(0, index),
          Object.assign({}, this.state.medications[index], {
            MedicationName: selected.label,
            MedicationId: selected.value
          }),
          ...this.state.medications.slice(index + 1)
        ]
      });
    }
  };

  changeMedicationDate = (date, i) => {
    var index = this.state.medications.findIndex(ele => {
      return ele.id == i;
    });
    if (date) {
      this.setState({
        medications: [
          ...this.state.medications.slice(0, index),
          Object.assign({}, this.state.medications[index], { date: date }),
          ...this.state.medications.slice(index + 1)
        ]
      });
    }
  };

  changeMedicationInfo = (event, i) => {
    forceInputUppercase(event);
    var index = this.state.medications.findIndex(ele => {
      return ele.id == i;
    });
    if (i >= 0) {
      this.setState({
        medications: [
          ...this.state.medications.slice(0, index),
          Object.assign({}, this.state.medications[index], {
            [event.target.name]: event.target.value
          }),
          ...this.state.medications.slice(index + 1)
        ]
      });
    }
  };

  removeMedication = (e, id) => {
    e.preventDefault();
    var index = this.state.medications.findIndex(ele => {
      return ele.id == id;
    });
    this.setState(this.state.medications.splice(index, 1));
    // form_step_2.vaccinations.splice(id,1);
  };

  changeNewZoom = val => {
    if (val) {
      this.setState({ newZoom: val });
    }
  };

  changeNewRotate = () =>{
    var nr = parseInt(this.state.newRotate) + 90;
    if (nr >= 360){
       nr = 0;
    }
    this.setState({ newRotate: nr });
  }

  // Image 01
  changeZoom01 = val => {
    if (val) {
      this.setState({ zoom01: val });
    }
  };

  changeRotate01 = () => {
    var nr = parseInt(this.state.rotate01) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate01: nr });
  };

  // Image 02
  changeZoom02 = val => {
    if (val) {
      this.setState({ zoom02: val });
    }
  };

  changeRotate02 = () => {
    var nr = parseInt(this.state.rotate02) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate02: nr });
  };

  // Image 03
  changeZoom03 = val => {
    if (val) {
      this.setState({ zoom03: val });
    }
  };

  changeRotate03 = () => {
    var nr = parseInt(this.state.rotate03) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate03: nr });
  };

  // Image 04
  changeZoom04 = val => {
    if (val) {
      this.setState({ zoom04: val });
    }
  };

  changeRotate04 = () => {
    var nr = parseInt(this.state.rotate04) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate04: nr });
  };

  // Image 05
  changeZoom05 = val => {
    if (val) {
      this.setState({ zoom05: val });
    }
  };

  changeRotate05 = () => {
    var nr = parseInt(this.state.rotate05) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate05: nr });
  };

  changePrimaryImageOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({
        selectedPrimaryImageOption: changedEvent.target.value
      });
    }
    else {
      this.setState({
        selectedPrimaryImageOption: '1'
      });
    }
  };

  newChangePrimaryImageOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      let bool_value = changedEvent.target.value == "true" ? true : false;   
      this.setState({ newSelectedPrimaryImageOption: bool_value });
    }
  };

  toggleBreeder = () => {
    this.setState({breeders_assigned_vaccine:[]});
    if (this.state.new_breeder) this.setState({ new_breeder: false });
    else this.setState({ new_breeder: true });
  };

  newMedication = (e, type) => {
    e.preventDefault();
    var arr = this.state.medications;
    form_step_2.medications.push({
      date: "",
      MedicationId: "",
      id: this.state.mediCount
    });
    var joined = arr.concat({
      date: "",
      MedicationId: "N/A",
      more_info: "",
      medType: type,
      id: this.state.mediCount
    });
    this.setState({ medications: joined, mediCount: this.state.mediCount + 1 });
  };

  changeDate = value => {
    this.setState({ arrival_date: value });
    
  };

  setArrivalDateOnDOBChange = dob => {
    const today = moment();
    const petAgeInWeeks = moment(today).diff(moment(dob) , 'week');
    if(petAgeInWeeks < 8){
        const afterEightWeeksFromDOB = moment(dob).add(8, 'weeks');
        const checkDate = afterEightWeeksFromDOB.isoWeekday();
          switch(checkDate){
            case 1:
              this.setState({arrival_date :moment(afterEightWeeksFromDOB).add(1, 'days').toDate()});
              break;
            case 2:
              this.setState({arrival_date:moment(afterEightWeeksFromDOB).add(7, 'days').toDate()});
              break;
            case 3:  
              this.setState({arrival_date :moment(afterEightWeeksFromDOB).add(6, 'days').toDate()});
              break;
            case 4:
              this.setState({arrival_date :moment(afterEightWeeksFromDOB).add(5, 'days').toDate()});
              break;
            case 5:
              this.setState({arrival_date :moment(afterEightWeeksFromDOB).add(4, 'days').toDate()});
              break;
            case 6:
              this.setState({arrival_date :moment(afterEightWeeksFromDOB).add(3, 'days').toDate()});
              break;
            case 7:
              this.setState({arrival_date :moment(afterEightWeeksFromDOB).add(2, 'days').toDate()});
              break;  
            default:
              break;  
          }   
    }else{
          const checkDate = today.isoWeekday();
          switch(checkDate){
            case 1:
              this.setState({arrival_date :moment(today).add(1, 'days').toDate()});
              break;
            case 2:
              this.setState({arrival_date:moment(today).add(7, 'days').toDate()});
              break;
            case 3:  
              this.setState({arrival_date :moment(today).add(6, 'days').toDate()});
              break;
            case 4:
              this.setState({arrival_date :moment(today).add(5, 'days').toDate()});
              break;
            case 5:
              this.setState({arrival_date :moment(today).add(4, 'days').toDate()});
              break;
            case 6:
              this.setState({arrival_date :moment(today).add(3, 'days').toDate()});
              break;
            case 7:
              this.setState({arrival_date :moment(today).add(2, 'days').toDate()});
              break;  
            default:
              break;  
          }
    }
  }

  changeDob = value => {
    this.setState({ date_of_birth: value });
    this.setArrivalDateOnDOBChange(value);
  };


  changeBreedCategory = selected => {
    if (selected) {
      this.setState({ breed_category_id: selected.value });
    }
  };

  nextStep = event => {  
      this.setState({
        currentStep: this.state.currentStep + 1,
        new_breeder: this.state.new_breeder,
        currentStepNotValid: false
      });
  };

  PrevStep = event => {
    this.setState({ currentStep: this.state.currentStep - 1 });
  };

  vaccineAssignBreeder = (e) => {
    e.preventDefault();
    var arr = this.state.breeders_assigned_vaccine;
    var scheduledays = moment(this.state.date_of_birth).add(parseInt(this.breeder_vaccine_duration_days), 'd').format('YYYY-MM-DD');
    if (this.state.breeders_vaccine_duration_id > 0 && this.state.breeders_vaccine_id > 0) {

      if (this.state.breeders_vaccine_duration_id !== 'none' && this.state.breeders_vaccine_id !== 'none') {
        var joined = arr.concat({
          MedicationId: this.state.breeders_vaccine_id,
          VaccineName: this.breeder_vaccine_label,
          DurationId: this.state.breeders_vaccine_duration_id,
          DurationDays: this.breeder_vaccine_duration_days,
          Type: "vaccine",
          DurationName: this.breeder_vaccine_duration_label,
          CalAdministeredDate: scheduledays
        });
        this.setState({ breeders_assigned_vaccine: joined });
      }
      this.setState({ breeders_vaccine_id: null });
    }
    else {
      NotificationManager.warning("Please check the vaccine schedule values again.");
    }

  };

  treatmentAssignBreeder = (e) => {
    e.preventDefault();   
    var arr = this.state.breeders_assigned_vaccine;
    var scheduledays = moment(this.state.date_of_birth).add(parseInt(this.state.breeder_treatment_duration_days), 'd').format('YYYY-MM-DD');
    if (this.state.breeders_treatment_duration_id > 0 && this.state.breeders_treatment_id > 0) {

      if (this.state.breeders_treatment_duration_id !== 'none' && this.state.breeders_treatment_id !== 'none') {
        var joined = arr.concat({
          MedicationId: this.state.breeders_treatment_id,
          VaccineName: this.breeder_treatment_label,
          DurationId: this.state.breeders_treatment_duration_id,
          DurationDays: this.breeder_treatment_duration_days,
          Type: "deworm",
          DurationName: this.breeder_treatment_duration_label,
          CalAdministeredDate: scheduledays
        });
        this.setState({ breeders_assigned_vaccine: joined });
      }
      this.setState({ breeders_treatment_id: null });
    }
    else {
      NotificationManager.warning("Please check the treatment schedule values again.");
    }



  };

  deleteVaccineAssignBreeder = (e, item) => {
    e.preventDefault();
    var index = this.state.breeders_assigned_vaccine.findIndex(ele => {
      return ele.MedicationId == item.MedicationId;
    });
    if(index > -1){
    this.setState(this.state.breeders_assigned_vaccine.splice(index, 1));
    }
    else{
      NotificationManager.error("Selected item not found");
    }

  };

  deleteBreederVaccines = (e, item) => {
    e.preventDefault();
    var index = this.state.breeders_assigned_vaccine.findIndex(ele => {
      return ele.MedicationId == item.MedicationId;
    });
    if(index > -1){
    this.setState(this.state.breeders_assigned_vaccine.splice(index, 1));
    }
    else{
    NotificationManager.error("Selected item not found");
    }

  };

  openBreedNamesSuggestionModal = (e) => {
    e.preventDefault();
    if(this.state.sex){
      let promptData = {
        date_of_birth : this.state.date_of_birth ? moment(this.state.date_of_birth).format("YYYY-MM-DD") :'',
        color_marking : this.state.color_markings ? this.state.color_markings : '',
        breed : this.state.petBreedName ? this.state.petBreedName : '',
        gender : this.state.sex ? this.state.sex : '',

      }      
      this.setState({ loadingPetNames : true, namePrompt : promptData });
    }else{
      NotificationManager.warning("Pet's gender required to generate names");
    }
    
  };

  openBreedPersonalityDescriptionModal = (e) => {
    e.preventDefault();
    if(this.state.pet_name){
      if(this.state.petBreedName){
        let promptData = {
          breed : this.state.petBreedName ? this.state.petBreedName : null,
          name : this.state.pet_name ? this.state.pet_name  : null,
          date_of_birth : this.state.date_of_birth ? moment(this.state.date_of_birth).format("YYYY-MM-DD") :'',
          gender :  this.state.sex ? this.state.sex : null,
          adult_weight : this.state.adult_weight ? this.state.adult_weight : null,
          color_marking : this.state.color_markings ? this.state.color_markings : null,
          zodiac: this.state.pet_zodiac ? this.state.pet_zodiac : null,  
        }     
        this.setState({ descriptionPrompt : promptData});   
      }else{
        NotificationManager.warning("Pet's breed required to generate personality description");
      }
    }else{
      NotificationManager.warning("Pet's name is required to generate personality description");
    }
  }

  openZodiacDescriptionModal = (e) => {
    e.preventDefault();
    if(!_.isEmpty(this.state.pet_zodiac)){
      if(this.state.petBreedName){
        if(this.state.pet_name){
          if(this.state.personality_description){
          let promptData = {
            zodiac: this.state.pet_zodiac,     
            name: this.state.pet_name ? this.state.pet_name: null,        
            description: this.state.personality_description ? this.state.personality_description: null,
            breed: this.state.petBreedName ? this.state.petBreedName : null,
          }       
          this.setState({ zodiacDescriptionPrompt: promptData });
        }else{
          NotificationManager.warning("Pet's personality description is required to generate zodiac description");
        }
        }else{
          NotificationManager.warning("Pet's name is required to generate zodiac description");
        }
 
     }else{
      NotificationManager.warning("Pet's breed is required to generate zodiac description");
     }
    }else{
      NotificationManager.warning("Pet's zodiac is required to generate zodiac description");
    }
  }

  onChangeVideoHandler = (event) => {  
    const selectedImageCount = this.state.loadedImages ? this.state.loadedImages.length : 0;
    let maxImages = 9;
    if(selectedImageCount <= maxImages){  
    var files = this.refs.videoFile &&  this.refs.videoFile.files &&  this.refs.videoFile.files.length > 0 ? this.refs.videoFile.files[0] : null;     
    this.setState({ selectedVideoFile: files,});
    }else{      
      this.setState({ selectedVideoFile: null, videoFileInputKey: Date.now(),});
      NotificationManager.error("Only 9 puppy images and 1 video is allowed.")
    }

  };


  handlePetNameChildResponse = (petNameData) => {
    this.setState({ pet_name : petNameData });
  }

  handlePetDescriptionResponse = (petDescriptionData) => {
    this.setState({ personality_description : petDescriptionData.personality_description, personality_description_full : petDescriptionData.personality_description_full });
  }

  handlePetZodiacDescriptionResponse = (petZodiacDescriptionData) => {
    this.setState({ pet_zodiac_description: petZodiacDescriptionData });
  }

  resetState = () => {
    this.setState(initialState);
    this.props.fetchAnimalTypes();
    this.props.fetchRegTypes();
    this.props.fetchBreeders();
    this.props.fetchBreedCategory();
    this.props.fetchAdministereds();
    this.props.fetchFoodTypes();
  };

  closeModal = () => {
    $("#confirm_samebreedernamesave_modal").modal("hide");
  };

  setInitialZodiac(){
    const zodiacTemp = this.getZodiac(moment().format('YYYY-MM-DD')); 
    this.setState({ pet_zodiac: zodiacTemp});
  }

  componentWillReceiveProps = (nextProps, prevProps) => {

    if (nextProps.data.addBreedTypeReducer.updateBreedType !== this.props.data.addBreedTypeReducer.updateBreedType) {  
      this.props.fetchUpdatedBreedTypeById(this.state.breedId);           
    }

    if(nextProps.updatedBreedTypeById !== this.props.updatedBreedTypeById){
      let breedsCopy = this.state.breeds.map(breed => {
        if(breed.id === nextProps.updatedBreedTypeById.id){
            return { label: nextProps.updatedBreedTypeById.breed_type, value: nextProps.updatedBreedTypeById.id }
        }else{
            return breed;
        }  
      })   
      this.setState({breeds : breedsCopy , cross_breed : nextProps.updatedBreedTypeById.cross_breed ? "YES" : "NO"  , breed_category_id : nextProps.updatedBreedTypeById.BreedCategoryId , showBreedEdit : false , sire : !nextProps.updatedBreedTypeById.cross_breed ? nextProps.updatedBreedTypeById.breed_type : "" , dam : !nextProps.updatedBreedTypeById.cross_breed ? nextProps.updatedBreedTypeById.breed_type : ""});
    }

    if(nextProps.breedInfo !== this.props.breedInfo && nextProps.breedInfo.id ){  
        if(!nextProps.breedInfo.BreedCategory && this.state.breedId !== "none" && this.state.breedId){
          this.setState({showBreedEdit : true})
        }else{
          this.setState({showBreedEdit : false})
        }
        this.setState({breed_category_id : nextProps.breedInfo.BreedCategory && nextProps.breedInfo.BreedCategory.id ? nextProps.breedInfo.BreedCategory.id : "none"  , cross_breed :  nextProps.breedInfo.cross_breed ? "YES" : "NO" , sire : !nextProps.breedInfo.cross_breed ? nextProps.breedInfo.breed_type : "" , dam : !nextProps.breedInfo.cross_breed ? nextProps.breedInfo.breed_type : "" });
    }

    if (nextProps.mRecordError && this.props.mRecordError !== nextProps.mRecordError) {
      if (nextProps.mRecordError.message && (nextProps.mRecordError.message === 'Pet Id already exists' || nextProps.mRecordError.message === 'Breeder name already exists')) {
        NotificationManager.error(
          nextProps.mRecordError.message
        );
        this.setState({ loading: false });
      } else {
        NotificationManager.error(
          "Something went wrong when saving the medical record"
        );
        this.resetState();
      }
    }
    if (
      nextProps.toa &&
      this.props.toa !== nextProps.toa &&
      nextProps.toa.length > 0
    ) {
      let options = [];
      nextProps.toa.map(p => {
        options.push({ label: p.type, value: p.id });
      });
      this.setState({ toa: options });
      if (nextProps.toa.length > 0) {
        this.setState({ PetId: nextProps.toa[0].id });
      }
    }


    if (
      nextProps.foodTypes &&
      this.props.foodTypes !== nextProps.foodTypes &&
      nextProps.foodTypes.length > 0
    ) {
      let options = [{ label: "SELECT THE FOOD TYPE", value: "none" }];
      nextProps.foodTypes.map(f => {
        options.push({ label: f.title, value: f.id , foodTypeImagePath : f.avatar_path , foodTypeImageName : f.avatar_file_name});
      });
      this.setState({ foodTypes: options });
      }
    


    if (
      nextProps.breeds &&
      this.props.breeds !== nextProps.breeds 
    ) {
      let options = [{ label: "SELECT BREED", value: "none" }];
      nextProps.breeds.map(p => {
        options.push({ label: p.breed_type, value: p.id });
      });
      this.setState({ breeds: options });
      if (nextProps.breeds.length > 0) {
        this.setState({ breedId: "none" });
      }
    }

    if (
      nextProps.reg_types &&
      this.props.reg_types !== nextProps.reg_types &&
      nextProps.reg_types.length > 0
    ) {
      let options = [];
      let loopflag = false;
      nextProps.reg_types.map(p => {
        if( p.type == 'NOT APPLICABLE' ){
          loopflag = true;    
          options.splice(0,0,{label: p.type, value: p.id});        
        }
        else if( p.type == 'PENDING'){         
          if(loopflag){
            options.splice(1,0,{label: p.type, value: p.id});
          }
          else{
            options.splice(0,0,{label: p.type, value: p.id});
          }        
        }
        else{  
          options.push({ label: p.type, value: p.id });
        }    
      });     
      this.setState({ reg_types: options });
      if (nextProps.reg_types.length > 0) {
        this.setState({ RegistrationTypeId: "N/A" });
      }
    }

    if (
      nextProps.breeders &&
      this.props.breeders !== nextProps.breeders &&
      nextProps.breeders.length > 0
    ) {
      let options = [{ label: "Select a breeder (City)", value: "N/A" }];
      nextProps.breeders.map(p => {
        let fname = p.breeder;       
        let bCity = p.addressCity;      
        let breeder = fname.concat(" (",bCity,")");
        options.push({ label: breeder, value: p.id });
      });
      this.setState({ breeders: options });
      if (nextProps.breeders.length > 0) {
        this.setState({ BreederId: "N/A" });
      }
    }


    if (
      nextProps.administered &&
      this.props.administered !== nextProps.administered &&
      nextProps.administered.length > 0
    ) {
      let VaccinationOptions = [{ label: "Select an option", value: "N/A" }];
      let DewormingOptions = [{ label: "Select an option", value: "N/A" }];

      nextProps.administered.map(p => {
        if (p.type === "vaccine") {
          VaccinationOptions.push({ label: p.name, value: p.id });
        }
        if (p.type === "deworm") {
          DewormingOptions.push({ label: p.name, value: p.id });
        }
      });

      this.setState({
        vaccinations: VaccinationOptions,
        dewormings: DewormingOptions,
        breeders_treatment: DewormingOptions,
        breeders_vaccine: VaccinationOptions,
      });

      if (nextProps.administered.length > 0) {
        this.state.medications.map((v, i) => {
          this.setState({
            medications: [
              ...this.state.medications.slice(0, i),
              Object.assign({}, this.state.medications[i], {
                MedicationId: "N/A"
              }),
              ...this.state.medications.slice(i + 1)
            ]
          });
        });
      }
    }
    if (
      this.props.data.addAnimalTypeReducer.setAnimalType !==
      nextProps.data.addAnimalTypeReducer.setAnimalType
    ) {
      this.props.fetchAnimalTypes();
    }

    if (
      this.props.data.administeredTypeReducer.setAdministered !==
      nextProps.data.administeredTypeReducer.setAdministered
    ) {
      this.props.fetchAdministereds();
    }

    if (
      this.props.data.regTypeReducer.setRegType !==
      nextProps.data.regTypeReducer.setRegType
    ) {
      this.props.fetchRegTypes();
    }

    if (
      this.props.data.foodTypeReducer.setFoodType !==
      nextProps.data.foodTypeReducer.setFoodType
    ) {
      this.props.fetchFoodTypes();
    }

    if (
      this.props.data.addBreedTypeReducer.setBreedType !==
      nextProps.data.addBreedTypeReducer.setBreedType
    ) {
      this.props.fetchBreedTypesByAnimal(this.state.PetId);
    }

    if (
      nextProps.breeds_category &&
      this.props.breeds_category !== nextProps.breeds_category &&
      nextProps.breeds_category.length > 0
    ) {
      let options = [{ label: "SELECT THE EMAIL TEMPLATE", value: "none" }];
      nextProps.breeds_category.map(p => {
        options.push({ label: p.name, value: p.id });
      });
      this.setState({ breeds_category: options });
      if (nextProps.breeds_category.length > 0) {
        this.setState({ breed_category_id: "none" });
      }
    }

    if (this.props.newRecord !== nextProps.newRecord) {
      if (nextProps.newRecord.mc_status === "draft") {
        NotificationManager.warning("Medical Record saved as draft.");
      }
      if (nextProps.newRecord.mc_status === "complete") {
        NotificationManager.success("Medical Record added succesfully.");
      }
      if (!this.state.littermate) {
        this.resetState();
        this.nextStep();
      } else {
        this.setState({
          loading: false,
          currentStep: 0,
          pet_id: "",
          micro_chip: "",
          weight: "",

          // Image 01
          imgSrc01: "",
          imgName01: "",
          zoom01: 1,
          editor01: "",
          rotate01: 0,

          // Image 02
          imgSrc02: "",
          imgName02: "",
          zoom02: 1,
          editor02: "",
          rotate02: 0,

          // Image 03
          imgSrc03: "",
          imgName03: "",
          zoom03: 1,
          editor03: "",
          rotate03: 0,

          // Image 04
          imgSrc04: "",
          imgName04: "",
          zoom04: 1,
          editor04: "",
          rotate04: 0,

          // Image 05
          imgSrc05: "",
          imgName05: "",
          zoom05: 1,
          editor05: "",
          rotate05: 0,

          //reset sex
          sex: ""
        });
      }
    }

    if (
      nextProps.newBreeder &&
      this.props.newBreeder !== nextProps.newBreeder
    ) {
      let arr = this.state.breeders;
      arr.push({ label: nextProps.newBreeder.breeder, value: nextProps.newBreeder.id });
      this.setState({ new_breederid: nextProps.newBreeder.id, breeders: arr });
      this.setState({
        b_phone: nextProps.newBreeder.phone ? nextProps.newBreeder.phone : "",
        b_usda: nextProps.newBreeder.usda_no ? nextProps.newBreeder.usda_no : "",
        b_address_line_1: nextProps.newBreeder.addressLine1 ? nextProps.newBreeder.addressLine1 : "",
        b_address_line_2: nextProps.newBreeder.addressLine2 ? nextProps.newBreeder.addressLine2 : "",
        b_address_city: nextProps.newBreeder.addressCity ? nextProps.newBreeder.addressCity : "",
        b_address_state: nextProps.newBreeder.addressState ? nextProps.newBreeder.addressState : "",
        b_address_country: nextProps.newBreeder.addressCountry ? nextProps.newBreeder.addressCountry : "",
        b_address_postal_code: nextProps.newBreeder.addressPostalCode
          ? nextProps.newBreeder.addressPostalCode
          : "",
        BreederId: nextProps.newBreeder.id ? nextProps.newBreeder.id : "",
      });     
       $("#confirm_samebreedernamesave_modal").modal("hide");
       $("#confirm_breedersave_modal").modal("hide");

    }

    if (nextProps.newBreederError && this.props.newBreederError !== nextProps.newBreederError) {

      if (nextProps.newBreederError.breederexists) {
        $("#confirm_breedersave_modal").modal("hide");
        $("#confirm_samebreedernamesave_modal").modal("show"); 
        this.setState({ loading: false });
      } else {
        NotificationManager.error(
          "Something went wrong when saving New Breeder"
        );
        this.resetState();
      }
    }

    if (
      nextProps.breeders_vaccine_duration &&
      this.props.breeders_vaccine_duration !== nextProps.breeders_vaccine_duration &&
      nextProps.breeders_vaccine_duration.length > 0
    ) {
      let options = [{ label: "Select Interval", value: "none" }];
      nextProps.breeders_vaccine_duration.map(p => {
        options.push({ label: p.label, value: p.id, days: p.days });
      });
      this.setState({ breeders_vaccine_duration: options });
      if (nextProps.breeders_vaccine_duration > 0) {
        this.setState({ breeders_vaccine_duration_id: "none" });
      }
    }
    
    if (
      nextProps.breedervaccinebyid &&
      this.props.breedervaccinebyid !== nextProps.breedervaccinebyid &&
      nextProps.breedervaccinebyid.length > 0
    ) {      
      let vaccine = nextProps.breedervaccinebyid;
      let arr = []
      vaccine.map(item => {       
        let form = {
          ...item,
          CalAdministeredDate: moment(this.state.date_of_birth).add(parseInt(item.DurationDays), 'd').format('MM-DD-YYYY')

        }
        arr.push(form);
      })
      this.setState({ breeders_assigned_vaccine: arr })
    }

    if (this.props.data.configReducer.configStatus !== nextProps.data.configReducer.configStatus) {
      let configs = nextProps.data.configReducer.configStatus;
      if(configs && configs.name == 'video_hoster'){
        this.setState({ videoHoster: configs.value });
      }                   
      } 

   
  };

  calculatePetAgeOnArrival = (arrivalDate) => {
    let diffInDays = moment(arrivalDate).diff(moment(this.state.date_of_birth) , 'days');
    let amountWeeks = Math.floor((diffInDays)/7);
    let remainingDays = diffInDays % 7;
    remainingDays = remainingDays.toFixed(0);
    let msg = `${amountWeeks} weeks, ${remainingDays} days`;
    if(diffInDays > 0){
      this.setState({petAgeOnArrival : msg});
    }else{
      this.setState({petAgeOnArrival : `Invalid arrival date`});
    }
  }

  getZodiac = (dob) => {
    //Date format YYYY-MM-DD
    const dateParts = dob.split('-');
    const month = parseInt(dateParts[1], 10);
    const day = parseInt(dateParts[2], 10);
    for (let i = 0; i < zodiacData.length; i++) {
      const zodiac = zodiacData[i];
      if (
        (month === zodiac.startMonth && day >= zodiac.startDay) ||
        (month === zodiac.endMonth && day <= zodiac.endDay) ||
        (month > zodiac.startMonth && month < zodiac.endMonth)
      ) {
        return zodiac.zodiac;
      }
    } 
    return 'Invalid date';
  }

  componentDidMount = () => {

    this.props.fetchAnimalTypes();
    this.props.fetchRegTypes();
    this.props.fetchBreeders();
    this.props.fetchAdministereds();
    this.props.fetchBreedCategory();
    this.props.fetchBreederDurartion();
    this.props.fetchFoodTypes();
    this.setState({ country: this.props.petShop.currentPetshop.country });
    this.setArrivalDateOnDOBChange(this.state.date_of_birth);
    this.props.getConfigByName({name:"video_hoster"});   
    this.setInitialZodiac();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if(prevState.breedId !== this.state.breedId && this.state.breedId !== "none" && this.state.breedId !== null){
      this.props.fetchBreedInfo(this.state.breedId);
    }

    if (prevState.PetId !== this.state.PetId) {
      if(this.state.PetId){
       this.props.fetchBreedTypesByAnimal(this.state.PetId);
      }
    }

    if(prevState.arrival_date !== this.state.arrival_date){
      this.calculatePetAgeOnArrival(this.state.arrival_date);
      if(this.arrivalDateIsValid(this.state.arrival_date)){
        this.setState({showArrivalDateValidateMessage : false});
      }else{
        this.setState({showArrivalDateValidateMessage : true});      
      };
    }

    if(prevState.date_of_birth !== this.state.date_of_birth){
      if(this.state.date_of_birth){
        const DOBTemp = moment(this.state.date_of_birth).format('YYYY-MM-DD');
        const zodiac = this.getZodiac(DOBTemp);     
        this.setState({ pet_zodiac: zodiac});
      }

      if(this.dateOfBirthRangeIsValid(this.state.date_of_birth)){
        this.setState({showDOBValidateMessage : false});   
      }else{
        this.setState({showDOBValidateMessage : true});
      }
    }

    if (prevState.BreederId !== this.state.BreederId) {
      if(this.state.BreederId && this.state.BreederId !== 'N/A'){
        this.props.fetchBreederById(this.state.BreederId);
        this.props.breeders.map(b => {
          if (b.id === this.state.BreederId) {
            this.setState({
              b_phone: b.phone ? b.phone : "",
              b_usda: b.usda_no ? b.usda_no : "",
              b_address_line_1: b.addressLine1 ? b.addressLine1 : "",
              b_address_line_2: b.addressLine2 ? b.addressLine2 : "",
              b_address_city: b.addressCity ? b.addressCity : "",
              b_address_state: b.addressState ? b.addressState : "",
              b_address_country: b.addressCountry ? b.addressCountry : "",
              b_address_postal_code: b.addressPostalCode
                ? b.addressPostalCode
                : ""
            });
          }
        });
        this.setState({ new_breeder: false });
      }
    }

    if (prevState.currentStep !== this.state.currentStep) {
      document.getElementById("progress-status").style.width =
        "calc(" + (parseInt(this.state.currentStep) + 1) * 25 + "% + 26px)";
    }
    if (
      this.props.data.medicalRecordsReducer.printMRecord !==
      prevProps.data.medicalRecordsReducer.printMRecord
    ) {
      this.childDownload();
    }
    if(this.props.data.medicalRecordsReducer.existingPetError && this.props.data.medicalRecordsReducer.existingPetError !== prevProps.data.medicalRecordsReducer.existingPetError){
      this.setState({ currentStep: 0, availablePetId: this.props.data.medicalRecordsReducer.existingPetError.petAvailable, loadingAvailableId: false })
      this.loadflag = false;
      NotificationManager.error(this.props.data.medicalRecordsReducer.existingPetError.message,'', 300);
 
     }
 
     if(this.props.data.medicalRecordsReducer.existingPet && this.props.data.medicalRecordsReducer.existingPet !== prevProps.data.medicalRecordsReducer.existingPet){
       this.setState({ availablePetId: this.props.data.medicalRecordsReducer.existingPet.petAvailable, loadingAvailableId: false  });   
       this.loadflag = false;
       NotificationManager.success(this.props.data.medicalRecordsReducer.existingPet.message,'',1000);
     }

     if (this.props.data.breederReducer.breedervaccineinfo !==
      prevProps.data.breederReducer.breedervaccineinfo) {
      let vaccine = this.props.data.breederReducer.breedervaccineinfo;
      let arr = []
      vaccine.map(item => {
        let form = {
          ...item,
          CalAdministeredDate: moment(newMedicalRecord.dob).add(parseInt(item.DurationDays), 'd').format('MM-DD-YYYY')
  
        }
        arr.push(form);
      })
      this.setState({ breeders_assigned_vaccine: arr })
  
    }

    if (this.state.uploadVideo && prevState.uploadVideo !== this.state.uploadVideo) {
      if(this.state.videoHoster == videoHoster.vimeo){ 
           const prevVideoId = prevState.uploadVideo ?  prevState.uploadVideo.uri : null; 
           this.setState({
               updatedVideoUrl: this.state.uploadVideo.player_embed_url,  
               updatedVideoId: this.state.uploadVideo.uri,   
               loadingVideo : false, 
               loadedVideoFile : true,
               video_source: "vimeo",
               video_name : this.state.uploadVideo.name
           });
             if(prevVideoId){
             this.deletePreviousVideo(prevVideoId); 
             }
           }
           else if(this.state.videoHoster == videoHoster.wistia){           
            let prevWistiaId = prevState.uploadVideo ?  prevState.uploadVideo.hashed_id : null; 
            this.setState({
               updatedVideoUrl:  this.state.uploadVideo.hashed_id,
               updatedVideoId: this.state.uploadVideo.hashed_id, 
               loadingVideo : false, 
               loadedVideoFile : true,
               video_source: "wistia",
               video_name : this.state.uploadVideo.name
             });
             if(prevWistiaId){
               this.deletePreviousVideo(prevWistiaId); 
               }
           }  
           
           NotificationManager.success("Video uploaded successfully");
    } 

   
  };

   resetExistingImages() {
    this.setState({
      // Image 01
      imgSrc01: "",
      imgName01: "",
      zoom01: 1,
      editor01: "",
      rotate01: 0,
    
      // Image 02
      imgSrc02: "",
      imgName02: "",
      zoom02: 1,
      editor02: "",
      rotate02: 0,
    
      // Image 03
      imgSrc03: "",
      imgName03: "",
      zoom03: 1,
      editor03: "",
      rotate03: 0,
    
      // Image 04
      imgSrc04: "",
      imgName04: "",
      zoom04: 1,
      editor04: "",
      rotate04: 0,
    
      // Image 05
      imgSrc05: "",
      imgName05: "",
      zoom05: 1,
      editor05: "",
      rotate05: 0,
    
      // Image 06
      imgSrc06: "",
      imgName06: "",
      zoom06: 1,
      editor06: "",
      rotate06: 0,
      
      // Image 07
      imgSrc07: "",
      imgName07: "",
      zoom07: 1,
      editor07: "",
      rotate07: 0,
      
      // Image 08
      imgSrc08: "",
      imgName08: "",
      zoom08: 1,
      editor08: "",
      rotate08: 0,
      
      // Image 09
      imgSrc09: "",
      imgName09: "",
      zoom09: 1,
      editor09: "",
      rotate09: 0,
      
      // Image 10
      imgSrc10: "",
      imgName10: "",
      zoom10: 1,
      editor10: "",
      rotate10: 0,

      selectedPrimaryImageOption: "1",
      loadedImages:[],
      newImgSrc:"",
      newZoom: 1,
      newRotate: 0,
    });
  };


  findMedicationId = id => {
    var index = form_step_2.medications.findIndex(ele => {
      return ele.id == id;
    });
    if ((index = -1)) {
      return 0;
    }
    return index;
  };

  AddNewAdministered = (e, type) => {
    e.preventDefault();
    this.setState({ mediModalType: type, showAdministered: true });
    // $("#add_administered_type").modal("show");
  };
  openConfirmModal = () => {    
    $("#confirm_breedersave_modal").modal("show");
  };
  openPdf = () => {
    this.props.updatePrintMRecord(this.props.newRecord.id);
  };
  items = [
    { title: "Puppy Records", to: "/medical-records" },
    { title: "New Puppy Records", to: "/medical-records/add" }
  ];
  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  handlerBreedData = () => {
    this.setState({
      selectedBreedData : {}  
    });
  }

  selectUploader = () => {
    let uploader = this.state.videoHoster;  
    switch(uploader){
      case "wistia":
       this.uploadVideoViaWistia();
       break;
      case "vimeo":  
       this.uploadVideoViaVimeo();
       break; 
    }
  }
 
   uploadVideoViaWistia = async (e) => { 
   let videoFile = this.state.selectedVideoFile;  
   if(videoFile){  
     this.setState({ loadingVideo : true, loadedVideoFile : false });  
     let uploadFileData = new FormData();
     uploadFileData.append('file', videoFile);
     uploadFileData.append('name',  videoFile.name);
     uploadFileData.append('project_id',config.videoUploader.wistia.project_id);
     uploadFileData.append('access_token',config.videoUploader.wistia.access_token);
       const options = {
         onUploadProgress: (progressEvent) => {
           const {loaded, total} = progressEvent;
           let percent = Math.floor( (loaded * 100) / total );        
     
           if( percent <= 70 ){   
             this.setState({ uploadPercentage: percent })
           }
           else if(90 < percent <= 100){     
             this.setState({ uploadPercentage: 60 })
           }
         }
       }  
       try {
        let uploadedVideo = await axios.post("https://upload.wistia.com", uploadFileData, options);
         this.setState({uploadVideo : uploadedVideo.data,})
       } catch (error) {         
         this.setState({ loadingVideo : false });
         NotificationManager.warning("An error occured while uploading the video. Please try again later.");
       }
   }
   else{
     NotificationManager.warning("Please select a video before proceeding with the upload.");
   }
 
  } 

 
   uploadVideoViaVimeo = async (e) => { 
   let videoFile = this.state.selectedVideoFile; 
   if(videoFile){
     let size = videoFile.size; 
     this.setState({ loadingVideo : true, loadedVideoFile : false });
     let binaryVideoFile =await  this.videoToBinary(videoFile); 
     let videoName = "PUPPY VIDEO - " + Math.random().toString().substr(2, 6);  
     try {
        let uploadedDummyVideo = await axios.post("https://api.vimeo.com/me/videos",
          {
            upload: {
              approach: "tus",
              size: size,
            },
            name: videoName,
            embed: {
              end_screen: {
                type: "empty",
              },
            },
          },
          {
            headers: {
              Authorization:
                "Bearer " + config.videoUploader.vimeo.access_token,
              "Content-Type": "application/json",
              Accept: "application/vnd.vimeo.*+json;version=3.4",
            },
          }
        );  
         if(uploadedDummyVideo && uploadedDummyVideo.data && uploadedDummyVideo.data.upload){           
           let tempUrl = uploadedDummyVideo.data.upload.upload_link ? uploadedDummyVideo.data.upload.upload_link : null;    
           if(tempUrl){         
             let uploadedVideo = await axios.patch(tempUrl,      
              binaryVideoFile,              
              {    
               headers: {
                'Tus-Resumable': '1.0.0',
                'Upload-Offset': 0,
                'Content-Type': 'application/offset+octet-stream',
                'Accept': 'application/vnd.vimeo.*+json;version=3.4'             
              }  
                         
              });              
              if(uploadedVideo && uploadedVideo.headers['upload-offset'] == size ){               
                this.setState({ uploadVideo : uploadedDummyVideo.data });
              }else{
                  this.setState({ loadingVideo : false });
                  NotificationManager.warning("An error occured while uploading the video. Please try again later.");
              }
             } 
           else{
               this.setState({ loadingVideo : false });
               NotificationManager.warning("An error occured while uploading the video. Please try again later.");
            }           
         }else{
            this.setState({ loadingVideo : false });
            NotificationManager.warning("An error occured while uploading the video. Please try again later.");
         }   
       } catch (error) { 
          if(error && error.response && error.response.data && error.response.data.error_code == 4101){     
            NotificationManager.warning("Allocated video quota has been reached.");
          }else if(error && error.response && error.response.data && error.response.data.error_code == 4102){  
            NotificationManager.warning("Weekly video quota has been reached.");
          }else if(error && error.response && error.response.data && error.response.data.error_code == 4104){    
            NotificationManager.warning("Daily video quota has been reached.");
          }else{      
            NotificationManager.warning("An error occured while uploading the video. Please try again later.");
          } 
          this.setState({ loadingVideo : false });
       }
   }
   else{
     NotificationManager.warning("Please select a video before proceeding with the upload.");
   }
 
  }
 
  videoToBinary =async (videoFile) =>{
   return new Promise((resolve,reject)=>{
     const reader = new FileReader();  
     reader.onload = function () {
       const result = reader.result;     
       return resolve(result);
     };  
     reader.onerror = function (error) {
       return reject(error);
     };
     reader.readAsArrayBuffer(videoFile);
   });
   
  }
 
  deletePreviousVideo = async(videoId) =>{
    if(videoId){
      if(this.state.videoHoster == videoHoster.wistia){
          try{
          let dd = await axios.delete(`https://api.wistia.com/v1/medias/${videoId}.json`,{
            headers: {
                Authorization: "Bearer"+" "+config.videoUploader.wistia.access_token         
              }});         
            }catch(err){      
            NotificationManager.warning("An error occured while deleting the previously uploaded video");
            }       
      }else if(this.state.videoHoster == videoHoster.vimeo){
          try {
            let deletedVideo = await axios.delete(`https://api.vimeo.com${videoId}`,
            {    
              headers: {
                Authorization: "Bearer "+config.videoUploader.vimeo.access_token,   
                  'Content-Type' : "application/json",
                  Accept : "application/vnd.vimeo.*+json;version=3.4" ,                  
              }   
            }
            );         
            
          } catch (error) {         
            NotificationManager.warning("An error occured while deleting the previously uploaded video");
          }
      }
    }
    else{
      NotificationManager.error("Previously uploaded video not found");
    }
  }

  _onChange = () => {
    this.resetExistingImages();
    let empty = []
    this.editedImageArray= [];
    const maxUploadImageCount = this.state.selectedVideoFile  ? 9 : 10 ;

    this.setState({ loadedImages : [], duplicateImages : [] },
      ()=>{
        var files = this.refs.multipleImageUploader.files;   
        var fileNo = 0;   
        if (!files || !files.length) {
          return false;
        }      
        if (files.length > maxUploadImageCount) {
          NotificationManager.error(`You can only upload maximum of ${maxUploadImageCount} images only.`);
          return false;
        }
    
        for (var file of files) {
          fileNo++;
    
          switch (fileNo) {
            case 1:         
              this.uploadImage01(file);
              break;
            case 2:
              this.uploadImage02(file);
              break;
            case 3:
              this.uploadImage03(file);
              break;
            case 4:
              this.uploadImage04(file);
              break;
            case 5:
              this.uploadImage05(file);
              break;
            case 6:
              this.uploadImage06(file);
              break;
            case 7:
              this.uploadImage07(file);
              break;
            case 8:
              this.uploadImage08(file);
              break;
            case 9:
              this.uploadImage09(file);
              break;
            case 10:
              this.uploadImage10(file);
              break;
            default:
              break;
          }
        }

      }
      );
 
  };

  selectHandler = (e,url) => {
    e.preventDefault();
   this.setState({ newImgSrc : url.src, newZoom : 1, newRotate: 0, selectedImage : url, newSelectedPrimaryImageOption: url.isPrimary  },);
  }

  saveHandle = () => {
    let imageNew = "";
    let image02 ="";
    let selectedArray =[];
    selectedArray = this.state.editedImages;   
    let allImages = this.state.loadedImages;  
    if(this.state.newSelectedPrimaryImageOption){
    allImages.map((image)=>{
        image.isPrimary = false
      });
    }
    const selectedImageIndex = allImages.findIndex((item)=> item.id == this.state.selectedImage.id);
    if(selectedImageIndex >= 0){
      if(this.state.newEditor){
        imageNew = this.state.newEditor.getImage(); 
        image02 = this.state.newEditor.getImage().toDataURL();
        allImages[selectedImageIndex].src = image02;
        allImages[selectedImageIndex].zoom = this.state.newZoom;
        allImages[selectedImageIndex].isPrimary = this.state.newSelectedPrimaryImageOption;
        allImages[selectedImageIndex].isResize = true;
        } 
     
    }
    this.setState({ loadedImages: allImages });
    NotificationManager.success("Image edited successfully");
  }

  resetHandle = ()=>{   
    let allImages = this.state.loadedImages;
    let allDuplicateImages = this.state.duplicateImages;    
    let dupIndex = allDuplicateImages.findIndex((item)=> item.id == this.state.selectedImage.id);
    let allIndex = allImages.findIndex((item)=> item.id == this.state.selectedImage.id);
    if(dupIndex >= 0 && allIndex >= 0){  
      allImages[allIndex].src = allDuplicateImages[dupIndex].src;
      allImages[allIndex].zoom = allDuplicateImages[dupIndex].zoom;
      this.setState({ loadedImages: allImages, testURL: allDuplicateImages[dupIndex].src });
    } 

  }

  setNewEditorRef = editor =>{
    if (editor) {
      this.setState({ newEditor: editor });  
    }
    
  }

  // Image 01
  uploadImage01 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader(); 
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) { 
          this.setState({
            imgSrc01: fixed, 
            imgName01: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 1, isPrimary : true, isResize : false} );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 1});  
          this.setState({ loadedImages: allImages, duplicateImages: duplicateImages  });      
  
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 02
  uploadImage02 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc02: fixed,
            imgName02: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom,  id : 2, isPrimary : false, isResize : false } );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 2}); 
          this.setState({loadedImages: allImages,  duplicateImages: duplicateImages });
  
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 03
  uploadImage03 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;   
    var reader = new FileReader(); 
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc03: fixed,
            imgName03: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 3, isPrimary : false, isResize : false} );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 3});
          this.setState({loadedImages: allImages,  duplicateImages: duplicateImages });
 
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 04
  uploadImage04 = (file) => {
    let allImages = this.state.loadedImages;    
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc04: fixed,
            imgName04: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 4, isPrimary : false, isResize : false} );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 4});
          this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 05
  uploadImage05 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc05: fixed,
            imgName05: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 5, isPrimary : false, isResize : false} );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 5});  
          this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 06
  uploadImage06 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader(); 
      var url = reader.readAsDataURL(file); 
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc06: fixed,
              imgName06: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 6, isPrimary : false, isResize : false} );
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 6}); 
            this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
          }.bind(this)
        );
      }.bind(this);
  };

  // Image 07
  uploadImage07 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader();  
      var url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc07: fixed,
              imgName07: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 7, isPrimary : false, isResize : false} );
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 7});  
            this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
          }.bind(this)
        );
      }.bind(this);
  };

  // Image 08
  uploadImage08 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader(); 
      var url = reader.readAsDataURL(file);   
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc08: fixed,
              imgName08: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 8, isPrimary : false, isResize : false} );
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 8});        
            this.setState({loadedImages: allImages, duplicateImages: duplicateImages  });
          }.bind(this)
        );
      }.bind(this);
  }; 

  // Image 09
  uploadImage09 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader(); 
      var url = reader.readAsDataURL(file); 
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc09: fixed,
              imgName09: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 9, isPrimary : false, isResize : false });
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 9 });        
            this.setState({ loadedImages: allImages, duplicateImages: duplicateImages  });
          }.bind(this)
        );
      }.bind(this);
  }; 

  // Image 10
  uploadImage10 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader(); 
    var url = reader.readAsDataURL(file);   
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
        this.setState({
          imgSrc10: fixed,
          imgName10: file.name
        });
        allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 10, isPrimary : false, isResize : false });
        duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 10 });        
        this.setState({ loadedImages: allImages, duplicateImages: duplicateImages  });
        }.bind(this)
        );
        }.bind(this);
  }; 
 
  // Image 01
  setEditorRef01 = editor => {
    if (editor) {
      this.setState({ editor01: editor });
    }
  };

  // Image 02
  setEditorRef02 = editor => {
    if (editor) {
      this.setState({ editor02: editor });
    }
  };

  // Image 03
  setEditorRef03 = editor => {
    if (editor) {
      this.setState({ editor03: editor });
    }
  };

  // Image 04
  setEditorRef04 = editor => {
    if (editor) {
      this.setState({ editor04: editor });
    }
  };

  // Image 05
  setEditorRef05 = editor => {
    if (editor) {
      this.setState({ editor05: editor });
    }
  };

   // Image 06
  setEditorRef06 = editor => {
    if (editor) {
      this.setState({ editor06: editor });
    }
  };

  // Image 07
  setEditorRef07 = editor => {
    if (editor) {
      this.setState({ editor07: editor });
    }
  };

  // Image 08
  setEditorRef08 = editor => {
    if (editor) {
      this.setState({ editor08: editor });
    }
  };

  // Image 09
  setEditorRef09 = editor => {
    if (editor) {
      this.setState({ editor09: editor });
     }
  };

  // Image 10
  setEditorRef10 = editor => {
    if (editor) {
      this.setState({ editor10: editor });
    }
  };
 
  play () {
   this.setState({
     playStop: !this.state.playStop
   })
 }


  goToSelectedBreedSettings = (e) => {
    e.preventDefault();
    this.setState({ selectedBreedData: null }, () => {
      let selectedBreedData = _.find(this.props.breeds, { 'id': this.state.breedId });
      if (selectedBreedData) {
          this.setState({ selectedBreedData: selectedBreedData});
      }
    })
  }

  render() {
    const {
      country,
      currentStep,
      toa,
      breeds,
      reg_types,
      foodTypes,
      breeders,
      arrival_date,
      pet_id,
      PetId,
      breedId,
      price,
      color_markings,
      date_of_birth,
      micro_chip,
      cross_breed,
      sex,
      RegistrationTypeId,
      FoodTypeId,
      sire,
      sire_number,
      dam,
      dam_number,
      new_breeder,
      BreederId,
      b_usda,
      b_address_line_1,
      b_address_line_2,
      b_address_city,
      b_address_state,
      b_address_country,
      b_address_postal_code,
      b_phone,
      new_b_name,
      new_b_usda_no,
      new_b_address_line_1,
      new_b_address_line_2,
      new_b_address_city,
      new_b_address_state,
      new_b_address_country,
      new_b_address_postal_code,
      new_b_phone,
      medications,
      vaccinations,
      dewormings,
      weight,
      currentFormIncomplete,
      mediModalType,
      notes,
      showAdministered,
      adult_weight,
      breed_category_id,
      breeds_category,
      breeders_vaccine_id,
      breeders_vaccine_duration,
      breeders_treatment_duration_id,
      breeders_treatment,
      breeders_treatment_id,
      breeders_vaccine_duration_id,
      breeders_vaccine,
      showBreedEdit  ,
      petAgeOnArrival,
      pet_name,
      personality_description, 
      pet_zodiac,
      pet_zodiac_description,
    } = this.state; 
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--lg m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        New Puppy Record
                        <small>
                          Complete this form to add a puppy record
                        </small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-wizard m-wizard--1 m-wizard--success">
                  <div className="m-wizard__head m-portlet__padding-x">
                    <div className="m-wizard__progress">
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow="100"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          id="progress-status"
                        ></div>
                      </div>
                    </div>
                    <div className="m-wizard__nav">
                      <div className="m-wizard__steps">
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 0
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 0 &&
                              "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_1"
                          id={"wizard-step0"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>1</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">
                              Pet Information
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 1
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 1 &&
                              "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_2"
                          id={"wizard-step1"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>2</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">
                              Breeder Information
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 2
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 2 &&
                              "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_3"
                          id={"wizard-step2"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>3</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">
                              Medical Information
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 3
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 3 &&
                              "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_4"
                          id={"wizard-step3"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>4</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">Print</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="m-wizard__form">
                    <form
                      onSubmit={this.submit}
                      className="m-form m-form--label-align-left- m-form--state-"
                    >
                      <div className="m-portlet__body m-portlet__body_grey">
                        {currentStep === 0 && (
                          <div id={"form-step0"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-form__section m-form__section--first">

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Upload Images
                                    </label>
                                    <div className="col-lg-8">
                                      <div>
                                        <input
                                          ref="multipleImageUploader"
                                          type="file"
                                          accept="image/*"
                                          multiple
                                          onChange={this._onChange}
                                        />
                                      </div>
                                      {/* <span className="m-form__help">
                                        Image size must not exceed 1MB.
                                      </span> */}
                                      <span
                                        className={
                                          form_step_0.avatar === "invalid" &&
                                            this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Add pet photo
                                      </span>
                                    </div>
                                  </div>
                                         {/* Start New preview */}

                                         <div className="form-group m-form__group row justify-content-md-center m--align-center">
                                    <div className="col-xl-6 offset-xl-2 col-md-6 offset-md-2">
                                    { this.state.newImgSrc &&
                                     <div>
                                      <div className="row">
                                          <div className="col-xs-8 col-sm-8">
                                            <AvatarEditor
                                              ref={this.setNewEditorRef}
                                              image={this.state.newImgSrc}
                                              border={0}
                                              width={200}
                                              height={200}
                                              borderRadius={0}
                                              color={[0, 0, 0, 0.6]} // RGBA
                                              scale={this.state.newZoom}
                                              rotate={this.state.newRotate}                                    
                                            />
                                          </div>                                          
                                          <div className="col-xs-2 col-md-4 d-none d-sm-none d-md-block">
                                              <div className="slider orientation-reversed">
                                                <div className="slider-group">
                                                  <div className="slider-vertical">
                                                    <Slider
                                                      min={1}
                                                      max={5}
                                                      step={0.1}
                                                      tooltip={false}
                                                      value={this.state.newZoom}
                                                      orientation="vertical"
                                                      onChange={this.changeNewZoom}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                          </div>
                                          <div className="col-xs-2 col-md-4 d-block d-sm-block d-md-none d-lg-none">                                  
                                            <Slider
                                              min={1}
                                              max={5}
                                              step={0.1}
                                              tooltip={false}
                                              value={this.state.newZoom}
                                              onChange={this.changeNewZoom}
                                            />                                  
                                         </div>                        
                                      </div>
                                      <div className="row justify-content-md-start m--align-start">
                                          <div className="col-xs-10 col-sm-10">
                                            <button
                                              type="button"
                                              className="btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--pill"
                                              onClick={this.changeNewRotate}
                                            >
                                              <i className="la la-rotate-right"></i>
                                            </button>
                                          </div>
                                        </div>
                                      <div className="row justify-content-md-start m--align-start">
                                          <div className="col-xs-8 col-sm-8">
                                            <input type="radio" name="primaryImage" className="ml-3" value={true} onChange={this.newChangePrimaryImageOption} checked={ this.state.newSelectedPrimaryImageOption } />
                                            <label for="image01" className="ml-2 mb-0">Set as Primary Image</label>
                                          </div>
                                      </div>                          
                                     <div className="row my-2">
                                          <div className="col-xs-10 col-sm-10">
                                            <div className="row justify-content-center m--align-center">
                                              <div className="col-4">
                                                <button type="button"
                                                  className="btn m-btn--pill btn-outline-warning btn-sm"
                                                  onClick={this.resetHandle}> Reset </button>
                                                </div>
                                              <div className="col-4">
                                             <button type="button"
                                              className="btn m-btn--pill btn-outline-success btn-sm"
                                              onClick={this.saveHandle}> Save </button>
                                            </div>
                                           </div>
                                          </div>
                                      </div>
                                 
                                     </div>
                                     }
                                      <div className="row justify-content-center m--align-start">
                                        <div className="col-12">
                                          <div className="row">
                                            {this.state.loadedImages && this.state.loadedImages.length> 0 && this.state.loadedImages.map((url,index) => (                                  
                                        
                                              <div className="col-4 mt-1 pl-2" onClick={(e) => this.selectHandler(e,url)}>

                                              <div className="profile-image-container">                                          
                                                <img src={url.src} alt="..." style={{width : "80px", height : "80px", cursor:"pointer"}}/>                      
                                              </div>                    
                                              </div>                      
                                            ))}
                                          </div>
                                        </div>
                                      </div>                    

                                    </div>
                                  </div>

                                  {/* End New preview */}                            
                                  {/*Start video Uploader */}
                                  <div className="form-group m-form__group row">
                                    <label class="col-lg-4 col-form-label">
                                      Upload Video
                                    </label>
                                    <div className="col-lg-4">  
                                    <div style={{ whiteSpace:"nowrap",overFlow:"hidden",textOverflow:"ellipsis"}}>                               
                                        <input
                                        id="file_input_file"
                                          ref="videoFile"
                                          key={this.state.videoFileInputKey}
                                          type="file"                                       
                                          accept = "video/mp4,video/x-m4v,video/*"                                      
                                          onChange={this.onChangeVideoHandler}
                                        />  
                                    </div>                              
                                                                                                                                                            
                                    </div>
                                    <div className="col-lg-2">
                                    <a className ="btn btn-outline-success m-btn m-btn--icon m-btn--icon-only"
                                           onClick={this.selectUploader}>
                                          <i class="la la-cloud-upload"></i>
                                        </a>  
                                    </div> 
                                    <div className="col-lg-2">
                                      {  this.state.loadingVideo &&                                  
                                        <Loader size={25} />
                                      }
                                    </div>                         
                                  </div> 
                                  { this.state.videoHoster == 'wistia' ?
                                   this.state.loadedVideoFile &&(
                                   <div className="form-group m-form__group row">
                                    <label className="col-lg-4"></label>                                  
                                    <div className="col-lg-8">                              
                                     <Video embedId = {this.state.updatedVideoUrl} />                               
                                    </div>                        
                                                                                          
                                  </div>)                                     
                                    :null
                                    } 
                                  {/*End video Uploader */}
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Pet Id<span style={{ color: "red" }}> *</span>:</label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        name="pet_id"
                                        onChange={this.checkPet}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={pet_id}
                                      />
                                      {/* <span className="m-form__help">
                                        Enter the pet id
                                      </span> */}
                                      <span
                                        className={
                                          form_step_0.pet_id === null &&
                                          this.state.currentStepNotValid
                                          ? "m-form__help_danger"
                                          : "display-none"
                                        }
                                      >
                                        Enter the pet id
                                      </span>
                                    </div>
                                    <div className="col-lg-2">
                                    {this.state.loadingAvailableId || this.loadflag  ?(
                                       <div className="center-row">                                         
                                        <Loader size={25} />
                                       </div>
                                       
                                     ):null}
                                    </div>
                                  </div>                               
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Type of Animal:
                                    </label>
                                    <div className="col-lg-6">
                                      <Select
                                        options={toa}
                                        value={PetId}
                                        name="PetId"
                                        onChange={this.changeToa}
                                        placeholder="Select the type of animal"
                                      />
                                      <span
                                        className={
                                          form_step_0.top === "invalid" &&
                                            this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Select the type of animal
                                      </span>
                                    </div>
                                    <div className="col-lg-2">
                                      <a
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#add_animal_type"
                                        className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                      >
                                        <i className="la la-plus"></i>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Breed:</label>
                                    <div className="col-lg-6">
                                      <Select
                                        options={breeds}
                                        value={breedId}
                                        name="breedId"
                                        onChange={this.changeBreed}
                                        placeholder="Select the breed"
                                      />
                                      <span
                                        className={
                                          form_step_0.breed === "invalid" &&
                                            this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Select the breed
                                      </span>
                                    </div> 
                                    <div className="col-lg-2">
                                      <a 
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#add_breed_type"
                                        className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                      >
                                        <i className="la la-plus"></i>
                                      </a>
                                    </div>
                                  </div>
                                  {showBreedEdit && breedId !== "none"?(                                  
                                     <div className="form-group m-form__group row mt-0 pt-0">
                                        <div className="col-lg-4"></div>
                                          <div className="col-lg-6">                                        
                                              <button type="button" style={{width : "100%"}} className="btn btn-sm m-btn--square  btn-outline-danger m-btn m-btn--outline-1x " onClick={(event) => this.goToSelectedBreedSettings(event)}>EDIT BREED TO ASSIGN EMAIL TEMPLATE</button>
                                          </div>
                                  </div> 
                                  ):(null)
                                                                                                   
                                  }      
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Price:
                                    </label>
                                    <div className="col-lg-6 input-group m-input-group">
                                      <div className="input-group-prepend">
                                        <span className="input-group-text">
                                          $
                                        </span>
                                      </div>
                                      <input
                                        type="number"
                                        name="price"
                                        value={price > 0 ? price : ""}
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder="0"
                                        aria-describedby="basic-addon1"
                                      />
                                    </div>
                                    {/* <span
                                      className={
                                        form_step_2.price === null &&
                                        this.state.currentStepNotValid
                                          ? "m-form__help_danger"
                                          : "display-none"
                                      }
                                    >
                                      Enter the price
                                    </span> */}
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Color Markings:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="color_markings"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={color_markings}
                                      />
                                      {/* <span className="m-form__help">
                                        Enter the color markings
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Date of Birth:
                                    </label>
                                    <div className="col-lg-8">
                                      <DatePicker
                                        selected={date_of_birth}
                                        value={date_of_birth}
                                        onChange={this.changeDob}
                                        onSelect={this.changeDob}
                                      />
                                      <br />
                                      <span
                                        className={
                                          form_step_0.dob === "invalid" &&
                                            this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Select the date of birth
                                      </span>
                                      <span
                                        className={
                                          form_step_0.dob_range === "invalid" &&
                                          this.state.currentStepNotValid && this.state.showDOBValidateMessage
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Invalid date of birth
                                      </span>
                                    </div>
                                  </div>


                                  <div className="form-group m-form__group row" style={{paddingBottom : "0px"}}>
                                    <label className="col-lg-4 col-form-label col-0">
                                      Arrival Date:
                                    </label>
                                    <div className="col-lg-4 col-12 arrival-date">
                                        <DatePicker 
                                          selected={arrival_date}
                                          value={arrival_date}
                                          onChange={this.changeDate}
                                          onSelect={this.changeDate}
                                        />
                                    </div>
                                    {petAgeOnArrival && (<div className="col-lg-4 pl-lg-0 mt-lg-0 pl-mt-0 mt-2 mb-2 col-12 pr-0" >
                                      <strong className="float-lg-right">Pet's age on arrival  :<br/> {petAgeOnArrival} </strong> 
                                    </div>)}                                   
                                  </div>
                                  {form_step_0.arrival_date_range === "invalidArrivalDate" && this.state.validateArrivalDate &&
                                          this.state.currentStepNotValid && this.state.showArrivalDateValidateMessage &&(
                                      <div className="form-group m-form__group row" style={{paddingTop : "0px"}}>
                                        <div className="col-lg-4 col-0">
                                        </div>
                                        <div className="col-lg-7 col-10">
                                          <span className="m-form__help_danger">
                                            Arrival date should be {config.petArrivalDateInWeeksFromDOB ? config.petArrivalDateInWeeksFromDOB : "8"} weeks greater than the selected "Date of Birth"
                                          </span>  
                                          
                                        </div>
                                        <div className="col-lg-1 col-2">
                                        <button type="button" onClick={() => this.skipArrivalDateValidation(false)} style={{float : "right"}} className="btn btn-outline-success btn-sm">Skip</button>
                                        </div>
                                      </div>
                                     )} 


                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Microchip:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="micro_chip"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={micro_chip}
                                      />
                                      {/* <span className="m-form__help">
                                        Enter the microchip
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Cross Breed:
                                    </label>
                                    <div className="col-lg-8">
                                      <select
                                        disabled="disabled"
                                        name="cross_breed"
                                        className="form-control m-input"
                                        placeholder=""
                                        value={cross_breed}
                                      >
                                        <option value="YES">YES</option>
                                        <option value="NO">NO</option>
                                      </select>
                                      {/* <span className="m-form__help">
                                        Is it a cross breed?
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Gender<span style={{ color: "red" }}> *</span>:</label>
                                    <div className="col-lg-8">
                                      <select
                                        name="sex"
                                        onChange={this.changeSelectionVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={sex}
                                      >
                                        <option value="">SELECT A GENDER</option>
                                        <option value="MALE">MALE</option>
                                        <option value="FEMALE">FEMALE</option>
                                      </select>
                                      <span
                                        className={
                                          form_step_0.sex === "invalid" &&
                                            this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Select the gender
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                    Current weight :
                                    </label>
                                    <div className="col-lg-8">
                                      <div className="input-group">
                                        <input
                                          type="number"
                                          name="weight"
                                          value={weight}
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          aria-describedby="basic-addon2"
                                        />
                                        <div className="input-group-append">
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            Lb
                                          </span>
                                        </div>
                                      </div>
                                      {/* <span className="m-form__help">
                                        Enter the pet weight (Lb)
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Adult Weight (lb):
                                    </label>
                                    <div className="col-lg-8">
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          name="adult_weight"
                                          value={adult_weight}
                                          onChange={this.changeAdultWeightVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          aria-describedby="basic-addon2"
                                        />
                                        <div className="input-group-append">
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            Lb
                                          </span>
                                        </div>
                                      </div>
                                      {/* <span className="m-form__help">
                                        Enter the pet weight (Lb)
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Registration Type:
                                    </label>
                                    <div className="col-lg-6">
                                      <Select
                                        options={reg_types}
                                        value={RegistrationTypeId}
                                        name="RegistrationTypeId"
                                        onChange={this.changeRegType}
                                        placeholder="SELECT THE REGISTRATION TYPE"
                                      />
                                      {/* <span className="m-form__help">
                                        Select the registration type
                                      </span> */}
                                    </div>
                                    <div className="col-lg-2">
                                      <a
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#add_reg_type"
                                        className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                      >
                                        <i className="la la-plus"></i>
                                      </a>
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                        Food Type:
                                    </label>
                                    <div className="col-lg-6">
                                      <Select
                                        options={foodTypes}
                                        value={FoodTypeId}
                                        name="FoodTypeId"
                                        onChange={this.changeFoodType}
                                        placeholder="SELECT THE FOOD TYPE"
                                      />
                                      
                                    </div>
                                    <div className="col-lg-2">
                                      <a
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#add_breed_food"
                                        className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                      >
                                        <i className="la la-plus"></i>
                                      </a>
                                    </div>
                                  </div>
                                  {
                                  FoodTypeId ? (
                                  <div className="form-group m-form__group row">
                                  <label className="col-lg-4">                                      
                                    </label>
                                    <div className="col-lg-6">
                                        
                                            <img style={{maxWidth:"150px",maxHeight:"150px"}}
                                              src={
                                                process.env.REACT_APP_S3_PATH +
                                                "/" +
                                                this.state.foodTypeImagePath + "/" + this.state.foodTypeImageName
                                              }
                                              alt=""
                                            />                                         
                                      </div>
                                   </div> 
                                ) : (<></>)
                                }
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Sire:</label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="sire"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={sire}
                                      />
                                      {/* <span className="m-form__help">
                                        Enter the sire
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Sire Number:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="sire_number"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        disabled={this.state.siredam_disable}
                                        placeholder=""
                                        value={sire_number}
                                      />
                                      {/* <span className="m-form__help">
                                        Enter the sire number
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Dam:</label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="dam"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={dam}
                                      />
                                      {/* <span className="m-form__help">
                                        Enter the dam
                                      </span> */}
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      Dam Number:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="dam_number"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        disabled={this.state.siredam_disable}
                                        placeholder=""
                                        value={dam_number}
                                      />
                                      {/* <span className="m-form__help">
                                        Enter the dam number
                                      </span> */}
                                   <span>                              
                                  </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Pet's Name:</label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        name="pet_name"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={pet_name}
                                      />                                                          
                                    </div>   
                                    <div className="col-lg-2">
                                      <a                                    
                                       onClick={(e)=> this.openBreedNamesSuggestionModal(e)}               
                                        className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                      >                                
                                        <i class="fa fa-magic" aria-hidden="true"></i>
                                      </a>
                                    </div>                               
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                    Personality Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                      className="form-control m-input"
                                      name="personality_description"
                                      onChange={this.changeVal}
                                      value={personality_description}
                                      id="exampleTextarea"
                                      rows="5"
                                    ></textarea>                             
                                    <div className='d-flex justify-content-end'>                                
                                    <div>
                                      <span className='pet-description-word-count'>{personality_description && personality_description.trim().length > 0 ? personality_description.trim().length: 0}/2000</span>
                                    </div>
                                  </div>
                                  <span
                                    className={personality_description && personality_description.trim().length > 2000 ?                                         
                                             "m-form__help_danger"
                                            :"display-none"}
                                  >
                                   Description length exceeds maximum
                                  </span>                                    
                                   </div>
                                   <div className="col-lg-2">
                                      <a
                                       className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                       onClick={(e)=> this.openBreedPersonalityDescriptionModal(e)}     
                                      >
                                         <i class="fa fa-magic" aria-hidden="true"></i>
                                      </a>
                                    </div>  
                                  </div>                   
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Pet's Zodiac:</label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        name="pet_zodiac"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={pet_zodiac}
                                      />                                                          
                                    </div>  
                                                              
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                    Zodiac Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                      className="form-control m-input"
                                      name="pet_zodiac_description"
                                      onChange={this.changeVal}
                                      value={pet_zodiac_description}
                                      id="exampleTextarea"
                                      rows="5"
                                    ></textarea>                             
                                    <div className='d-flex justify-content-end'>                                
                                    <div>
                                      <span className='pet-description-word-count'>{pet_zodiac_description && pet_zodiac_description.trim().length > 0 ? pet_zodiac_description.trim().length: 0}/500</span>
                                    </div>
                                  </div>
                                  <span
                                    className={pet_zodiac_description && pet_zodiac_description.trim().length > 500 ?                                         
                                             "m-form__help_danger"
                                            :"display-none"}
                                  >
                                   Description length exceeds maximum
                                  </span>                                    
                                   </div>
                                   <div className="col-lg-2">
                                      <a
                                       className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                       onClick={(e)=> this.openZodiacDescriptionModal(e)}     
                                      >
                                         <i class="fa fa-magic" aria-hidden="true"></i>
                                      </a>
                                    </div>  
                                  </div>
                                
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">Welcome Email<span style={{ color: "red" }}> *</span>:</label>
                                    <div className="col-lg-6">
                                      <Select
                                        disabled="disabled"
                                        options={breeds_category}
                                        value={breed_category_id}
                                        name="breed_category_id"
                                        placeholder="Email template"
                                      />
                                      <span
                                        className={
                                          form_step_0.breed_category_id === "invalid" &&
                                            this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Select a Welcome Email Template
                                      </span>
                                    </div>
                                    {/* <div className="col-lg-2">
                                      <a
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#add_breed_type"
                                        className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                      >
                                        <i className="la la-plus"></i>
                                      </a>
                                    </div> */}
                                  </div>
                                  
                                    </div> 
                              </div>
                            </div>
                          </div>
                        )}
                        {currentStep === 1 && (
                          <div id={"form-step1"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-form__section m-form__section--first row">
                                  <label className="m-checkbox m-checkbox--bold m-checkbox--state-success">
                                    <input
                                      onChange={this.toggleBreeder}
                                      value={new_breeder}
                                      checked={new_breeder}
                                      type="checkbox"
                                    />{" "}
                                    New Breeder
                                    <span></span>
                                  </label>
                                </div>
                                {!new_breeder ? (
                                  <div className="m-form__section">
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Breeder:
                                      </label>
                                      <div className="col-lg-6">
                                        <Select
                                          options={breeders}
                                          value={BreederId}
                                          name="BreederId"
                                          onChange={this.changeBreeder}
                                          placeholder="Select the breeder"
                                        />
                                        {/* <span className="m-form__help">
                                          Select the breeder
                                        </span> */}
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        USDA Number:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_usda}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="USDA number"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Address Line 1:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_address_line_1}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="Line 1"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Address Line 2:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_address_line_2}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="Line 2"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        City:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_address_city}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="City"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        State:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_address_state}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="State"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Country:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_address_country}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="Country"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Postal Code:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_address_postal_code}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="Postal Code"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Phone:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={b_phone}
                                          className="form-control m-input"
                                          readonly=""
                                          placeholder="Phone"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                    <div className="m-form__section">
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Breeder:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_name}
                                            name="new_b_name"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.breederName ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the breeder name
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          USDA Number:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_usda_no}
                                            name="new_b_usda_no"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.usdaNo === "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the USDA number
                                        </span>
                                        </div>
                                      </div>

                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Line 1:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_line_1}
                                            name="new_b_address_line_1"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressLine1 ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the Address Line 1
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Line 2:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_line_2}
                                            name="new_b_address_line_2"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressLine2 ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the Address Line 2
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address City:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_city}
                                            name="new_b_address_city"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressCity ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the City
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address State:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_state}
                                            name="new_b_address_state"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressState ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the State
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Country:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_country}
                                            name="new_b_address_country"
                                            className="form-control m-input"
                                            onChange={this.changeVal}
                                          />
                                          <span
                                            className={
                                              form_step_1.addressCountry ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the Country
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Postal Code:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_postal_code}
                                            name="new_b_address_postal_code"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressPostalCode ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the Postal Code
                                        </span>
                                        </div>
                                      </div>

                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Breeder's Phone:
                                      </label>
                                        <div className="col-lg-6">
                                          <PhoneInput
                                            country={country}
                                            className="form-control"
                                            placeholder="Enter the breeder's phone"
                                            value={new_b_phone}
                                            onChange={value =>
                                              this.setState({
                                                new_b_phone: value
                                              })
                                            }
                                          />
                                          <span
                                            className={
                                              form_step_1.breederPhone ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the breeder's phone
                                        </span>
                                        </div>
                                      </div>
                                      <div className="m-accordion__item m-accordion__item--danger" style={{
                                        paddingBottom: "50px", border: "1px dotted", padding: "25px",
                                        marginBottom: "35px"
                                      }}>
                                        <div className="m-accordion__item-head collapsed" srole="tab" id="m_accordion_5_item_1_head" data-toggle="collapse" href="#m_accordion_5_item_1_body" aria-expanded="false">

                                          <span className="m-accordion__item-title" style={{ fontSize: "14px" }}>Vaccine Schedule</span>
                                          <span className="m-accordion__item-icon" style={{ paddingLeft: "10px" }}><i className="la la-long-arrow-down"></i>
                                          </span>
                                        </div>
                                        <div className="m-accordion__item-body collapse" id="m_accordion_5_item_1_body" role="tabpanel" aria-labelledby="m_accordion_5_item_1_head" data-parent="#m_accordion_5">
                                          <div className="panel-body">
                                            <div className="m-form__section">
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Interval:
                                                </label>
                                                <div className="col-lg-6 col-12">
                                                  <Select
                                                    options={breeders_vaccine_duration}
                                                    value={breeders_vaccine_duration_id}
                                                    name="breeders_vaccine_duration_id"
                                                    onChange={this.changeBreederVaccineDuration}
                                                    placeholder="Select the Timeline"
                                                  />

                                                </div>
                                              </div>

                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Vaccination Name:
                                                </label>
                                                <div className="col-lg-6 col-10" >
                                                  <Select
                                                    options={breeders_vaccine}
                                                    value={breeders_vaccine_id}
                                                    name="breeders_vaccine_id"
                                                    onChange={this.changeBreederVaccine}
                                                    placeholder="Select the Vaccine"
                                                  />
                                                </div>
                                                <div className="col-lg-2 col-2">
                                                  <a
                                                    href="#"
                                                    data-toggle="modal"
                                                    data-target="#add_administered_type"
                                                    className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                                    onClick={e =>
                                                      this.AddNewAdministered(
                                                        e,
                                                        "vaccine"
                                                      )
                                                    }
                                                  >
                                                    <i className="la la-plus"></i>
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="row">
                                                {/* <div className="col-4 col-md-offset-2">

                                                </div> */}
                                                <div className="col-lg-2 offset-lg-5 offset-2">
                                                  <button
                                                    type="button"
                                                    onClick={e =>
                                                      this.vaccineAssignBreeder(e)
                                                    }
                                                    className="btn m-btn--pill btn-outline-primary btn-sm mx-2"
                                                    style={{ margin: "auto" }}

                                                  >
                                                    <span>
                                                      <span> Add to Schedule </span>
                                                    </span>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="m-widget4">
                                              {this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine.filter(p => {
                                                return p.Type === "vaccine";
                                              }).map((vac) => (
                                                <div className="form-group">
                                                  <hr style={{ borderTop: "1px dashed" }}></hr>
                                                  <div className="col-12 m-widget4__item">
                                                    <div className="row">
                                                      <div className="col-4">
                                                        <div className="m-widget4__info">
                                                          <span className="m-widget4__text">
                                                            {vac.DurationName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-6" style={{ borderLeft: "2px solid" }}>
                                                        <div className="m-widget4__info" style={{ display: "inline-block", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                          <span className="m-widget4__text">
                                                            {vac.VaccineName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-2">
                                                        <div className="m-widget4__ext">
                                                          <i className="la la-times-circle" onClick={e =>
                                                            this.deleteVaccineAssignBreeder(e, vac)
                                                          } ></i>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>


                                              )) : null

                                              }
                                              {/* <hr style={{ border: "1px dashed" }}></hr> */}
                                            </div>

                                          </div>

                                        </div>
                                      </div>
                                      <div className="m-accordion__item m-accordion__item--danger" style={{
                                        paddingBottom: "50px", border: "1px dotted", padding: "25px",
                                        marginBottom: "35px"
                                      }} >
                                        <div className="m-accordion__item-head collapsed" srole="tab" id="m_accordion_5_item_1_head" data-toggle="collapse" href="#Treatmet_1" aria-expanded="false">

                                          <span className="m-accordion__item-title" style={{ fontSize: "14px" }}>Treatment Schedule</span>
                                          <span className="m-accordion__item-icon" style={{ paddingLeft: "10px" }}><i className="la la-long-arrow-down"></i>
                                          </span>
                                        </div>
                                        <div className="m-accordion__item-body collapse" id="Treatmet_1" role="tabpanel" aria-labelledby="m_accordion_5_item_1_head" data-parent="#m_accordion_5">
                                          <div className="panel-body">
                                            <div className="m-form__section">
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Interval:
                                                </label>
                                                <div className="col-lg-6 col-12">
                                                  {/* <Select
                                                    options={breeders_vaccine_duration}
                                                    value={breeders_vaccine_duration_id}
                                                    name="breeders_vaccine_duration_id"
                                                    onChange={this.changeBreederVaccineDuration}
                                                    placeholder="Select the Timeline"
                                                  /> */}
                                                  <Select
                                                    options={breeders_vaccine_duration}
                                                    value={breeders_treatment_duration_id}
                                                    name="breeders_treatment_duration_id"
                                                    onChange={this.changeBreederTreatmentDuration}
                                                    placeholder="Select the Timeline"
                                                  />
                                                </div>
                                              </div>

                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Treatment Name:
                                                </label>
                                                <div className="col-lg-6 col-10">
                                                  <Select
                                                    options={breeders_treatment}
                                                    value={breeders_treatment_id}
                                                    name="breeders_treatment_id"
                                                    onChange={this.changeBreederTreatment}
                                                    placeholder="Select the Treatment"
                                                  />
                                                </div>
                                                <div className="col-lg-2 col-2">
                                                  <a
                                                    href="#"
                                                    data-toggle="modal"
                                                    data-target="#add_administered_type"
                                                    className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                                    onClick={e =>
                                                      this.AddNewAdministered(
                                                        e,
                                                        "deworm"
                                                      )
                                                    }
                                                  >
                                                    <i className="la la-plus"></i>
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="row">
                                                <div className="col-lg-2 offset-lg-5 offset-2">
                                                  <button
                                                    type="button"
                                                    onClick={e =>
                                                      this.treatmentAssignBreeder(e)
                                                    }
                                                    className="btn m-btn--pill btn-outline-primary btn-sm mx-2"
                                                    style={{ margin: "auto" }}

                                                  >
                                                    <span>
                                                      <span> Add to Schedule </span>
                                                    </span>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="m-widget4">
                                              {this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine.filter(p => {
                                                return p.Type === "deworm";
                                              }).map((vac, i) => (
                                                <div className="form-group" key={i}>
                                                  <hr style={{ borderTop: "1px dashed" }}></hr>
                                                  <div className="col-12 m-widget4__item">
                                                    <div className="row">
                                                      <div className="col-4">
                                                        <div className="m-widget4__info">
                                                          <span className="m-widget4__text">
                                                            {vac.DurationName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-6" style={{ borderLeft: "2px solid" }}>
                                                        <div className="m-widget4__info" style={{ display: "inline-block", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                          <span className="m-widget4__text">
                                                            {vac.VaccineName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-2">
                                                        <div className="m-widget4__ext">
                                                          <i className="la la-times-circle" onClick={e =>
                                                            this.deleteVaccineAssignBreeder(e, vac)
                                                          } ></i>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                              )) : null

                                              }

                                            </div>

                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        )}
                        {currentStep === 2 && (
                          <div id={"form-step2"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-portlet__head pl-0">
                                  <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                      <h5 className="m-portlet__head-text">
                                        Vaccinations
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div className="m-form__section m-form__section--first row mb-2">
                                  <PerfectScrollbar style={{ width: "100%" }}>
                                    <div
                                      className="m-accordion m-accordion--default"
                                      id="m_accordion_4"
                                      role="tablist"
                                    >
                                      {this.state.breeders_assigned_vaccine.length > 0
                                        ? this.state.breeders_assigned_vaccine.filter(p => {
                                          return p.Type === "vaccine";
                                        }).map((p, i) => (
                                          <div
                                            className="m-accordion__item overlay-visible"
                                            key={i}
                                          >
                                            <div
                                              className="m-accordion__item-head collapsed"
                                              role="tab"
                                              id={"m_accordion_4_item_new" + i + "_head"}
                                              data-toggle="collapse"
                                              href={
                                                "#m_accordion_4_item_new" + i + "_body"
                                              }
                                              aria-expanded="    false"
                                            >
                                              <span className="m-accordion__item-icon">
                                                <i className="fas fa-syringe"></i>
                                              </span>
                                              {p.Type === "vaccine" ? (
                                                <span className="m-accordion__item-title">
                                                  {" "}
                                          Vaccination {i + 1} -{" "}
                                                  {p.VaccineName}{" "}
                                                </span>
                                              ) : p.Type === "deworm" ? (
                                                <span className="m-accordion__item-title">
                                                  {" "}
                                          Treatment {i + 1} -{" "}
                                                  {p.VaccineName}
                                                </span>
                                              ) : null}
                                              <span className="m-accordion__item-mode"></span>
                                            </div>
                                            <div
                                              className="m-accordion__item-body collapse"
                                              id={"m_accordion_4_item_new" + i + "_body"}
                                              role="tabpanel"
                                              aria-labelledby={
                                                "m_accordion_4_item_new" + i + "_head"
                                              }
                                              data-parent="#m_accordion_4"
                                            >
                                              <div className="m-accordion__item-content">
                                                <div className="m-widget4">
                                                  <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                      <i className="fas fa-calendar-alt mr-2"></i>
                                                      <span>
                                                        <strong>Date Administered: </strong>
                                                      </span>
                                                      {p.CalAdministeredDate}
                                                    </span>
                                                  </div>
                                                  <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                      <i className="fas fa-clipboard-check mr-2"></i>
                                                      <span>
                                                        <strong>Vaccination Name: </strong>
                                                      </span>
                                                      {p.VaccineName}
                                                    </span>
                                                  </div>
                                                  <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                      <i className="fas fa-info-circle mr-2"></i>
                                                      <span>
                                                        <strong>Notes (Serial, Expiration, Etc.): </strong>
                                                      </span>
                                                      <input type="textarea" onChange={(e) => { p.note = e.target.value }} className="form-control m-input" />
                                                    </span>
                                                  </div>
                                                  <div className="m-widget4__item m--align-right">
                                                    <span className="m-widget4__sub">
                                                      <a
                                                        href="#"
                                                        onClick={(e) =>
                                                          this.deleteBreederVaccines(e, p)
                                                        }
                                                        className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                                      >
                                                        <span>
                                                          <i className="la la-minus-circle mr-2"></i>
                                                          <span>Delete</span>
                                                        </span>
                                                      </a>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                        : null}
                                    </div>                         
                                  </PerfectScrollbar>
                                </div>
                                <div className="m-form__section m-form__section--first row mb-2">
                                  <div
                                    className="m-accordion m-accordion--default"
                                    id="m_accordion_4"
                                    role="tablist"
                                    style={{ width: "100%" }}
                                  >
                                    {medications
                                      .filter(m => {
                                        return m.medType === "vaccine";
                                      })
                                      .map((p, i) => (
                                        <div
                                          className="m-accordion__item overlay-visible accodian-danger"
                                          key={i}
                                        >
                                          <div
                                            className="m-accordion__item-head collapsed"
                                            role="tab"
                                            id={
                                              "m_accordion_4_item_" +
                                              i +
                                              "_head"
                                            }
                                            data-toggle="collapse"
                                            href={
                                              "#m_accordion_4_item_" +
                                              i +
                                              "_body"
                                            }
                                            aria-expanded="    false"
                                          >
                                            <span className="m-accordion__item-icon">
                                              <i className="fas fa-syringe"></i>
                                            </span>
                                            <span className="m-accordion__item-title">
                                              Vaccination {p.MedicationId !== 'N/A' ? (" - " + p.MedicationName) : ''}
                                              {(form_step_2.medications[
                                                this.findMedicationId(p.id)
                                              ].date === null ||
                                                form_step_2.medications[
                                                  this.findMedicationId(p.id)
                                                ].MedicationId === null) &&
                                                this.state.currentStepNotValid ? (
                                                  <i
                                                    className="fas fa-exclamation-triangle ml-2"
                                                    style={{ color: "red" }}
                                                  ></i>
                                                ) : null}
                                            </span>

                                            <span className="m-accordion__item-mode"></span>
                                          </div>
                                          <div
                                            className="m-accordion__item-body collapse"
                                            id={
                                              "m_accordion_4_item_" +
                                              i +
                                              "_body"
                                            }
                                            role="tabpanel"
                                            aria-labelledby={
                                              "m_accordion_4_item_" +
                                              i +
                                              "_head"
                                            }
                                            data-parent="#m_accordion_4"
                                          >
                                            <div className="m-accordion__item-content">
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">
                                                  Date Administered:
                                                </label>
                                                <div className="col-lg-8">
                                                  <DatePicker
                                                    selected={p.date}
                                                    value={p.date}
                                                    onChange={d =>
                                                      this.changeMedicationDate(
                                                        d,
                                                        p.id
                                                      )
                                                    }
                                                    onSelect={d =>
                                                      this.changeMedicationDate(
                                                        d,
                                                        p.id
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    className={
                                                      form_step_2.medications[
                                                        this.findMedicationId(
                                                          p.id
                                                        )
                                                      ].date === null &&
                                                        this.state
                                                          .currentStepNotValid
                                                        ? "m-form__help_danger"
                                                        : "display-none"
                                                    }
                                                  >
                                                    Select the date of administered
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">
                                                  Vaccination Name:
                                                </label>
                                                <div className="col-lg-6">
                                                  <Select
                                                    options={vaccinations}
                                                    value={p.MedicationId}
                                                    name="MedicationId"
                                                    onChange={e => {
                                                      this.changeAdministered(
                                                        e,
                                                        p.id
                                                      );
                                                    }}
                                                    placeholder="Select the administered type"
                                                  />
                                                  <span
                                                    className={
                                                      form_step_2.medications[
                                                        this.findMedicationId(
                                                          p.id
                                                        )
                                                      ].MedicationId === null &&
                                                        this.state
                                                          .currentStepNotValid
                                                        ? "m-form__help_danger"
                                                        : "display-none"
                                                    }
                                                  >
                                                    Select the vaccination
                                                  </span>
                                                </div>
                                                <div className="col-lg-2">
                                                  <a
                                                    href="#"
                                                    data-toggle="modal"
                                                    data-target="#add_administered_type"
                                                    className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                                    onClick={e =>
                                                      this.AddNewAdministered(
                                                        e,
                                                        "vaccine"
                                                      )
                                                    }
                                                  >
                                                    <i className="la la-plus"></i>
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">
                                                  Notes (Serial, Expiration, Etc.):
                                                </label>
                                                <div className="col-lg-6">
                                                  <input
                                                    type="text"
                                                    value={p.more_info}
                                                    name="more_info"
                                                    onChange={e => {
                                                      this.changeMedicationInfo(
                                                        e,
                                                        p.id
                                                      );
                                                    }}
                                                    className="form-control m-input"
                                                  />
                                                  {/* <span className="m-form__help">
                                                    Enter more information
                                                  </span> */}
                                                </div>
                                              </div>
                                              <div className="m-widget4__item m--align-right">
                                                <span className="m-widget4__sub">
                                                  <a
                                                    href="#"
                                                    onClick={e =>
                                                      this.removeMedication(
                                                        e,
                                                        p.id
                                                      )
                                                    }
                                                    className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                                  >
                                                    <span>
                                                      <i className="la la-minus-circle mr-2"></i>
                                                      <span>Delete</span>
                                                    </span>
                                                  </a>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                                <div
                                  className="m-form__section row mt-2  mr-2"
                                  style={{ float: "right" }}
                                >
                                  <a
                                    href="#"
                                    onClick={event =>
                                      this.newMedication(event, "vaccine")
                                    }
                                    className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill"
                                  >
                                    <span>
                                      <i className="la la-plus"></i>
                                      <span>New Vaccination</span>
                                    </span>
                                  </a>
                                </div>
                              </div>
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-portlet__head pl-0">
                                  <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                      <h5 className="m-portlet__head-text">
                                        Treatments
                                        <small>
                                          Dewormings, Surgeries, Etc.
                                        </small>
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div className="m-form__section m-form__section--first row mb-2">
                                  <PerfectScrollbar style={{ width: "100%" }}>
                                    <div
                                      className="m-accordion m-accordion--default"
                                      id="m_accordion_4"
                                      role="tablist"
                                    >
                                      {this.state.breeders_assigned_vaccine.length > 0
                                        ? this.state.breeders_assigned_vaccine.filter(p => {
                                          return p.Type === "deworm";
                                        }).map((p, j) => (
                                          <div
                                            className="m-accordion__item overlay-visible"
                                            key={j}
                                          >
                                            <div
                                              className="m-accordion__item-head collapsed"
                                              role="tab"
                                              id={"m_accordion_4_item_new_T" + j + "_head"}
                                              data-toggle="collapse"
                                              href={
                                                "#m_accordion_4_item_new_T" + j + "_body"
                                              }
                                              aria-expanded="    false"
                                            >
                                              <span className="m-accordion__item-icon">
                                                <i className="fas fa-syringe"></i>
                                              </span>
                                              {p.Type === "deworm" ? (
                                                <span className="m-accordion__item-title">
                                                  {" "}
                                                  Treatment {j + 1} -{" "}
                                                  {p.VaccineName}{" "}
                                                </span>
                                              ) : p.Type === "deworm" ? (
                                                <span className="m-accordion__item-title">
                                                  {" "}
                                                  Vaccination {j + 1} -{" "}
                                                  {p.VaccineName}
                                                </span>
                                              ) : null}
                                              <span className="m-accordion__item-mode"></span>
                                            </div>
                                            <div
                                              className="m-accordion__item-body collapse"
                                              id={"m_accordion_4_item_new_T" + j + "_body"}
                                              role="tabpanel"
                                              aria-labelledby={
                                                "m_accordion_4_item_new_T" + j + "_head"
                                              }
                                              data-parent="#m_accordion_4"
                                            >
                                              <div className="m-accordion__item-content">
                                                <div className="m-widget4">
                                                  <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                      <i className="fas fa-calendar-alt mr-2"></i>
                                                      <span>
                                                        <strong>Date Administered: </strong>
                                                      </span>
                                                      {p.CalAdministeredDate}
                                                    </span>
                                                  </div>
                                                  <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                      <i className="fas fa-clipboard-check mr-2"></i>
                                                      <span>
                                                        <strong>Vaccination Name: </strong>
                                                      </span>
                                                      {p.VaccineName}
                                                    </span>
                                                  </div>
                                                  <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                      <i className="fas fa-info-circle mr-2"></i>
                                                      <span>
                                                        <strong>Notes (Serial, Expiration, Etc.): </strong>
                                                      </span>
                                                      <input type="textarea" onChange={(e) => { p.note = e.target.value }} className="form-control m-input" />
                                                    </span>
                                                  </div>
                                                  {/* <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                      <i className="fas fa-info-circle mr-2"></i>
                                                      <span>
                                                        <strong>Notes (Serial, Expiration, Etc.): </strong>
                                                      </span>
                                                      {p.more_info}
                                                    </span>
                                                  </div> */}
                                                  <div className="m-widget4__item m--align-right">
                                                    <span className="m-widget4__sub">
                                                      <a
                                                        href="#"
                                                        onClick={(e) =>
                                                          this.deleteBreederVaccines(e, p)
                                                        }
                                                        className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                                      >
                                                        <span>
                                                          <i className="la la-minus-circle mr-2"></i>
                                                          <span>Delete</span>
                                                        </span>
                                                      </a>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                        : null}
                                    </div>
                                    {/* <div className="mt-2 mb-3" style={{ float: "right" }}>
                                      <a
                                        href="#"
                                        className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill"
                                        onClick={event =>
                                          this.newMedication(event, "vaccine")
                                        }
                                      >
                                        <span>
                                          <i className="la la-plus"></i>
                                          <span>New Vaccination</span>
                                        </span>
                                      </a>
                                    </div> */}

                                  </PerfectScrollbar>

                                </div>
                                <div className="m-form__section m-form__section--first row mb-2">
                                  <div
                                    className="m-accordion m-accordion--default"
                                    id="m_accordion_5"
                                    role="tablist"
                                    style={{ width: "100%" }}
                                  >
                                    {medications
                                      .filter(m => {
                                        return m.medType === "deworm";
                                      })
                                      .map((p, i) => (
                                        <div
                                          className="m-accordion__item overlay-visible accodian-danger"
                                          key={i}
                                        >
                                          <div
                                            className="m-accordion__item-head collapsed"
                                            role="tab"
                                            id={
                                              "m_accordion_5_item_" +
                                              i +
                                              "_head"
                                            }
                                            data-toggle="collapse"
                                            href={
                                              "#m_accordion_5_item_" +
                                              i +
                                              "_body"
                                            }
                                            aria-expanded="    false"
                                          >
                                            <span className="m-accordion__item-icon">
                                              <i className="fas fa-syringe"></i>
                                            </span>
                                            <span className="m-accordion__item-title">
                                              Treatment {p.MedicationId !== 'N/A' ? (" - " + p.MedicationName) : ''}
                                              {(form_step_2.medications[
                                                this.findMedicationId(p.id)
                                              ].date === null ||
                                                form_step_2.medications[
                                                  this.findMedicationId(p.id)
                                                ].MedicationId === null) &&
                                                this.state.currentStepNotValid ? (
                                                  <i
                                                    className="fas fa-exclamation-triangle ml-2"
                                                    style={{ color: "red" }}
                                                  ></i>
                                                ) : null}
                                            </span>
                                            <span className="m-accordion__item-mode"></span>
                                          </div>
                                          <div
                                            className="m-accordion__item-body collapse"
                                            id={
                                              "m_accordion_5_item_" +
                                              i +
                                              "_body"
                                            }
                                            role="tabpanel"
                                            aria-labelledby={
                                              "m_accordion_5_item_" +
                                              i +
                                              "_head"
                                            }
                                            data-parent="#m_accordion_5"
                                          >
                                            <div className="m-accordion__item-content">
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">
                                                  Date Administered:
                                                </label>
                                                <div className="col-lg-8">
                                                  <DatePicker
                                                    selected={p.date}
                                                    value={p.date}
                                                    onChange={d =>
                                                      this.changeMedicationDate(
                                                        d,
                                                        p.id
                                                      )
                                                    }
                                                    onSelect={d =>
                                                      this.changeMedicationDate(
                                                        d,
                                                        p.id
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    className={
                                                      form_step_2.medications[
                                                        this.findMedicationId(
                                                          p.id
                                                        )
                                                      ].date === null &&
                                                        this.state
                                                          .currentStepNotValid
                                                        ? "m-form__help_danger"
                                                        : "display-none"
                                                    }
                                                  >
                                                    Select the date of administered
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">
                                                  Vaccination Name
                                                </label>
                                                <div className="col-lg-6">
                                                  <Select
                                                    options={dewormings}
                                                    value={p.MedicationId}
                                                    name="MedicationId"
                                                    onChange={e => {
                                                      this.changeAdministered(
                                                        e,
                                                        p.id
                                                      );
                                                    }}
                                                    placeholder="Select the administered type"
                                                  />
                                                  <span
                                                    className={
                                                      form_step_2.medications[
                                                        this.findMedicationId(
                                                          p.id
                                                        )
                                                      ].MedicationId === null &&
                                                        this.state
                                                          .currentStepNotValid
                                                        ? "m-form__help_danger"
                                                        : "display-none"
                                                    }
                                                  >
                                                    Select the vaccination:
                                                  </span>
                                                </div>
                                                <div className="col-lg-2">
                                                  <a
                                                    href="#"
                                                    data-toggle="modal"
                                                    data-target="#add_administered_type"
                                                    className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                                    onClick={e =>
                                                      this.AddNewAdministered(
                                                        e,
                                                        "deworm"
                                                      )
                                                    }
                                                  >
                                                    <i className="la la-plus"></i>
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">
                                                  Notes (Serial, Expiration, Etc.):
                                                </label>
                                                <div className="col-lg-6">
                                                  <input
                                                    type="text"
                                                    value={p.more_info}
                                                    name="more_info"
                                                    onChange={e => {
                                                      this.changeMedicationInfo(
                                                        e,
                                                        p.id
                                                      );
                                                    }}
                                                    className="form-control m-input"
                                                  />
                                                  {/* <span className="m-form__help">
                                                    Enter more information
                                                  </span> */}
                                                </div>
                                              </div>
                                              <div className="m-widget4__item m--align-right">
                                                <span className="m-widget4__sub">
                                                  <a
                                                    href="#"
                                                    onClick={e =>
                                                      this.removeMedication(
                                                        e,
                                                        p.id
                                                      )
                                                    }
                                                    className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                                  >
                                                    <span>
                                                      <i className="la la-minus-circle mr-2"></i>
                                                      <span>Delete</span>
                                                    </span>
                                                  </a>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                                <div
                                  className="m-form__section row mt-2  mr-2"
                                  style={{ float: "right" }}
                                >
                                  <a
                                    href="#"
                                    onClick={event =>
                                      this.newMedication(event, "deworm")
                                    }
                                    className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill"
                                  >
                                    <span>
                                      <i className="la la-plus"></i>
                                      <span>New Treatment</span>
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2">
                                <div className="m-portlet__head pl-0">
                                  <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                      <h5 className="m-portlet__head-text">
                                        Notes
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div className="m-form__section m-form__section--first row mb-2">
                                  <textarea
                                    className="form-control m-input"
                                    name="notes"
                                    value={notes}
                                    onChange={this.changeVal}
                                    id="exampleTextarea"
                                    rows="3"
                                  ></textarea>
                                  {/* <span className="m-form__help">
                                    Enter the note
                                  </span> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {currentStep === 3 && (
                          <div id={"form-step3"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2">
                                <div className="m-form__section m-form__section--first">
                                  <div className="col-xl-12">
                                    <div className="m-form__section m-form__section--first">
                                      <h3 className="m--font-success mb-2">
                                        Medical Record created Successfully.
                                      </h3>
                                    </div>
                                    <div
                                      className="m-form__section my-3 row"
                                      style={{ textALign: "center" }}
                                    >
                                      <NavLink
                                        to={`/medical-records/${this.props.newRecord.id}`}
                                        className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill mr-2"
                                      >
                                        <span>
                                          <i className="la la-desktop"></i>
                                          <span>Edit</span>
                                        </span>
                                      </NavLink>
                                      <a
                                        href="#"
                                        onClick={() => this.openPdf()}
                                        className="btn btn-primary m-btn m-btn--icon m-btn--pill"
                                      >
                                        <span>
                                          <i className="la la-print"></i>
                                          <span>Print</span>
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {currentStep !== 3 && (
                        <div className="m-portlet__foot">
                          <div className="row">
                            <div className="col-lg-12">
                              {this.state.loading == false ? (
                                <div
                                  className="row"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  {currentStep !== 0 && (
                                    <div>
                                      <button
                                        type="button"
                                        onClick={this.PrevStep}
                                        className="btn btn-secondary m-btn--pill mx-2 mt-2"
                                      >
                                        <span>
                                          <i className="la la-arrow-left"></i>
                                          &nbsp;&nbsp;
                                          <span>Back</span>
                                        </span>
                                      </button>
                                    </div>
                                  )}
                                  { new_breeder !== false && (
                                    <div>
                                      <button
                                        type="button"                                      
                                        onClick={this.openConfirmModal}
                                        className="btn btn-primary m-btn--pill mx-2 mt-2"
                                      >
                                        <span>
                                          &nbsp;&nbsp;
                                          <span>Add New Breeder</span>
                                          &nbsp;&nbsp;
                                          {/* <i className="la la-arrow-right"></i> */}
                                        </span>
                                      </button>
                                    </div>
                                  )}
                                  {currentStep === 2 ? (
                                    currentFormIncomplete ? (
                                      <div style={{ textAlign: "right" }}>
                                        <button
                                          type="button"
                                          onClick={e =>
                                            this.validateStep(false)
                                          }
                                          className="btn btn-primary m-btn--pill mt-2"
                                        >
                                          <span>
                                            <i className="la la-check"></i>
                                            &nbsp;&nbsp;
                                            <span>Submit as Draft</span>
                                          </span>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={e => this.validateStep(true)}
                                          className="btn btn-primary m-btn--pill ml-2 mt-2"
                                        >
                                          <span>
                                            <i className="fas fa-plus"></i>
                                            &nbsp;&nbsp;
                                            <span>Submit & add littermate</span>
                                          </span>
                                        </button>
                                      </div>
                                    ) : (
                                        <div>
                                          <button
                                            type="button"
                                            onClick={e =>
                                              this.validateStep(false)
                                            }
                                            className="btn btn-primary m-btn--pill mt-2"
                                          >
                                            <span>
                                              <i className="fas fa-plus"></i>
                                            &nbsp;&nbsp;
                                            <span>Submit</span>
                                            </span>
                                          </button>
                                          <button
                                            type="button"
                                            onClick={e => this.validateStep(true)}
                                            className="btn btn-primary m-btn--pill ml-2 mt-2"
                                          >
                                            <span>
                                              <i className="la la-check"></i>
                                            &nbsp;&nbsp;
                                            <span>Submit & add littermate</span>
                                            </span>
                                          </button>
                                        </div>
                                      )
                                  ) : (
                                      currentStep !== 3 && new_breeder !== true && (
                                        <div>
                                          <button
                                            type="button"
                                            onClick={e =>
                                              this.confirmUploadingImages(e)
                                            }
                                            className="btn btn-primary m-btn--pill mt-2"
                                          >
                                            <span>
                                              <span>Save & Continue</span>
                                            &nbsp;&nbsp;
                                            <i className="la la-arrow-right"></i>
                                            </span>
                                          </button>
                                        </div>
                                      )
                                    )}
                                </div>
                              ) : (
                                  <div className="center-row">
                                    <Loader size={50} />
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_breedersave_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirmation
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>You are about to create a new breeder. If you need to make any changes to this breeder later, please go to breeders tab.</p>
              </div>
              <div className="modal-footer">
                <div>
                  <button
                    type="button"
                    className="btn btn-secondary m-btn--pill mx-2"
                    data-dismiss="modal"
                  >
                    Cancel
                    </button>
                  <button
                    type="button"
                    onClick={() => this.newBreederCreate()}
                    className="btn btn-primary m-btn--pill"
                  >
                    Create
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_samebreedernamesave_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                 WARNING
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>A breader already exists with the same name and city. Are you sure you want to continue?</p>
              </div>
              <div className="modal-footer">
                <div>
                  <button
                    type="button"
                    onClick={() => this.closeModal()}
                    className="btn btn-secondary m-btn--pill mx-2"
                    data-dismiss="modal"
                  >
                    Cancel
                    </button>
                  <button
                    type="button"
                    onClick={() => this.existBreederCreate()}
                    className="btn btn-primary m-btn--pill"
                  >
                    Create
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="image-preview-model"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
         >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Preview Images
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"                
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">

                <div className="row justify-content-center">
            
                {  this.state.loadedImages &&  this.state.loadedImages.length > 0 && this.state.loadedImages[0] && this.state.loadedImages[0].src && (
                  <div className="col-4">
                    <AvatarEditor
                        ref={this.setEditorRef01}
                        image={this.state.loadedImages[0] ? this.state.loadedImages[0].src: null}
                        border={0}
                        width={125}
                        height={125}
                        borderRadius={0}
                        color={[0, 0, 0, 0.6]} // RGBA
                        scale= {1}
                        rotate={this.state.rotate01}
                      />                      

                  </div>
                  )} 
                  {this.state.loadedImages &&  this.state.loadedImages.length > 1 && this.state.loadedImages[1] && this.state.loadedImages[1].src && (
                  <div className="col-4">
                    <AvatarEditor
                        ref={this.setEditorRef02}
                        image={this.state.loadedImages[1] ? this.state.loadedImages[1].src: null}
                        border={0}
                        width={125}
                        height={125}
                        borderRadius={0}
                        color={[0, 0, 0, 0.6]} // RGBA
                        scale={1}
                        rotate={this.state.rotate02}
                      />

                  </div>
                )}
                {this.state.loadedImages &&  this.state.loadedImages.length > 2 && this.state.loadedImages[2] && this.state.loadedImages[2].src && (
                  <div className="col-4">
                    <AvatarEditor
                        ref={this.setEditorRef03}
                        image={this.state.loadedImages[2] ? this.state.loadedImages[2].src: null}
                        border={0}
                        width={125}
                        height={125}
                        borderRadius={0}
                        color={[0, 0, 0, 0.6]} // RGBA
                        scale={1}
                        rotate={this.state.rotate03}
                      />

                  </div>
                )} 
                </div>
                <div className="row justify-content-center">            
                    {this.state.loadedImages &&  this.state.loadedImages.length > 3 && this.state.loadedImages[3] && this.state.loadedImages[3].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef04}
                          image={this.state.loadedImages[3] ? this.state.loadedImages[3].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate01}
                        />                      

                    </div>
                    )} 
                    {this.state.loadedImages &&  this.state.loadedImages.length > 4 && this.state.loadedImages[4] && this.state.loadedImages[4].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef05}
                          image={this.state.loadedImages[4] ? this.state.loadedImages[4].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                        rotate={this.state.rotate02}
                        />

                    </div>
                  )}
                    {this.state.loadedImages &&  this.state.loadedImages.length > 5 && this.state.loadedImages[5] && this.state.loadedImages[5].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef06}
                          image={this.state.loadedImages[5] ? this.state.loadedImages[5].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate03}
                        />

                    </div>
                  )} 
              </div>  
              <div className="row justify-content-center">            
                    {this.state.loadedImages &&  this.state.loadedImages.length > 6 && this.state.loadedImages[6] && this.state.loadedImages[6].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef07}
                          image={this.state.loadedImages[6] ? this.state.loadedImages[6].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale = {1}
                          rotate={this.state.rotate01}
                        />                      

                    </div>
                    )} 
                    {this.state.loadedImages &&  this.state.loadedImages.length > 7 && this.state.loadedImages[7] && this.state.loadedImages[7].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef08}
                          image={this.state.loadedImages[7] ? this.state.loadedImages[7].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate02}
                        />

                    </div>
                  )}
                    {this.state.loadedImages &&  this.state.loadedImages.length > 8 && this.state.loadedImages[8] && this.state.loadedImages[8].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef09}
                          image={this.state.loadedImages[8] ? this.state.loadedImages[8].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate03}
                        />

                    </div>
                  )} 
              </div> 
              <div className="row justify-content-center">            
                    {this.state.loadedImages &&  this.state.loadedImages.length > 9 && this.state.loadedImages[9] && this.state.loadedImages[9].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef10}
                          image={this.state.loadedImages[9] ? this.state.loadedImages[9].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale = {1}
                          rotate={this.state.rotate01}
                        />                      

                    </div>
                    )}             
        
              </div>          
              </div>
              <div className="modal-footer">           
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                          Cancel
                    </button>
                    <button
                          type="button"
                          onClick={() => this.setImagesToUpload()}
                          className="btn btn-primary m-btn--pill"
                        >
                          Upload
                    </button>              
                      
              </div>
            </div>
          </div>
        </div>
        <AddAdministeredTypeForm type={mediModalType} />
        <AddAnimalTypeForm />
        <AddBreedTypeForm selectedBreedData={this.state.selectedBreedData}  actionBreed={this.handlerBreedData}/>
        <AddRegTypeForm />
        <AddFoodTypeForm actionFoodType={()=> {}}/>
        <MRecordPDF setClick={this.acceptMethods.bind(this)} />
        <PetNameSuggestion petNamePrompt={this.state.namePrompt} parentPetNameCallback={this.handlePetNameChildResponse} />
        <PetDescriptionSuggestion petDescriptionPrompt={this.state.descriptionPrompt} parentPetDescriptionCallback={this.handlePetDescriptionResponse} />      
        <PetZodiacDescriptionSuggestion petZodiacDescriptionPrompt={this.state.zodiacDescriptionPrompt} parentPetZodiacDescriptionCallback={this.handlePetZodiacDescriptionResponse} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  petShop: state.petShopReducer,
  toa: state.addAnimalTypeReducer.animalTypes,
  breeds: state.addBreedTypeReducer.breedsByAnimal,
  reg_types: state.regTypeReducer.regTypes,
  foodTypes: state.foodTypeReducer.foodTypes,
  updatedBreedTypeById : state.addBreedTypeReducer.updatedBreedTypeById,
  breeders: state.breederReducer.breederList,
  administered: state.administeredTypeReducer.administeredList,
  newRecord: state.medicalRecordsReducer.mRecord,
  newAvatar: state.medicalRecordsReducer.avtr,
  data: state,
  mRecordError: state.medicalRecordsReducer.mRecordError,
  breedTypesError: state.addBreedTypeReducer.breedTypesError,
  administeredListError: state.administeredTypeReducer.administeredListError,
  breedeListError: state.breederReducer.breederListError,
  breeds_category: state.breederReducer.breederCategory,
  breeders_vaccine_duration: state.breederReducer.breederVaccineDuration,
  newBreeder: state.breederReducer.newBreeder,
  newBreederError: state.breederReducer.newBreederError,
  breedervaccinebyid: state.breederReducer.breedervaccineinfo,
  breedInfo : state.addBreedTypeReducer.breedInfo,
});

const mapDispatchToProps = dispatch => ({
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchBreedTypesByAnimal: animal => {
    dispatch(fetchBreedTypesByAnimal(animal));
  },
  fetchUpdatedBreedTypeById : id => {
    dispatch(fetchUpdatedBreedTypeById(id));
  },
  fetchRegTypes: () => {
    dispatch(fetchRegTypes());
  },
  addMedicalRecord: attrs => {
    dispatch(addMedicalRecord(attrs));
  },
  fetchBreeders: () => {
    dispatch(fetchBreeders());
  },
  fetchAdministereds: () => {
    dispatch(fetchAdministereds());
  },
  attachAvatar: avtr => {
    dispatch(attachAvatar(avtr));
  },
  updatePrintMRecord: id => {
    dispatch(updatePrintMRecord(id));
  },
  fetchBreedCategory: () => {
    dispatch(fetchBreedCategory());
  },
  findPetById: id => {
    dispatch(findPetById(id));
  },
  fetchBreederDurartion: () => {
    dispatch(fetchBreederDurartion());
  },
  addBreeder: breeder => {
    dispatch(addBreeder(breeder));
  },
  fetchBreederById: id => {
    dispatch(fetchBreederById(id));
  },
  fetchBreedInfo : id => {
    dispatch(fetchBreedInfo(id));
  },
  fetchFoodTypes : () => {
    dispatch(fetchFoodTypes());
  },
  getConfigByName: (data) => {
    dispatch(getConfigByName(data));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Datamodal)
);